import moment from 'moment';
import { FULL_MOMENTO_DATA_PROVIDERS } from '../dataProviders';
import {
  DF_LAUNCH_DATE,
  DF_PREPATCH_LAUNCH_DATES,
  DF_SEASON2_DATES,
  DF_SEASON3_DATES,
  DF_SEASON4_DATES,
  MIDNIGHT_GLOBAL_LAUNCH_DATES,
  MIDNIGHT_SEASON1_MPLUS_DATES,
  MIDNIGHT_SEASON2_DATES,
  TWW_GLOBAL_LAUNCH_DATES,
  TWW_PRE_ACCESS_LAUNCH_DATES,
  TWW_PREPATCH_LAUNCH_DATES,
  TWW_SEASON1_MPLUS_DATES,
  TWW_SEASON2_DATES,
  TWW_SEASON3_CUTOFFS_DATES,
  TWW_SEASON3_DATES,
  TWW_SEASON3_LEGION_REMIX_DATES
} from './dates';
import { Expansion, ExpansionPatch } from '../expansion';
import { RealmConnectionType } from '../sharedTypes';
import { FAR_FUTURE_DATE } from '../sharedConstants';
import { mdiDF2Timestamps } from './mdi';
import {
  DYNAMIC_BRACKET_EVENT_START,
  getSeasonPartitionEventId,
  MAX_ALLOWED_ACTIVE_SEASON,
  SeasonPartitionType,
  TScoringSystem,
  TSeasonDef
} from '../mythicPlus';

// we have to use this elsewhere just for this season, since this is when partitions were introduced
export const SEASON_SL1_PARTITION_EVENT_ID = getSeasonPartitionEventId(5, 0);

export const SEASONS: TSeasonDef[] = [
  {
    id: 72,
    slug: 'season-mn-2',
    name: 'Season 2',
    short_name: 'MN2',
    scoringSystem: TScoringSystem.V11,
    title: 'MN Season 2',
    expansionId: Expansion.Midnight,
    assetExpansionId: Expansion.Midnight,
    patchId: ExpansionPatch.Patch_1210,
    assetPatchId: ExpansionPatch.Patch_1210,
    skipAffixAlerts: false,
    icon: 'inv_knife_1h_ulatekfang_d_01_poison',
    // NOTE: need to explicitly not include the 12+ range for guile here due
    // to other code not handling it properly
    affixThreshold: [4, 7, 10],
    affixLevelRanges: [
      {
        min: 4,
        max: 11,
        affixes: [148, 158, 160, 162]
      },
      {
        min: 7,
        affixes: [9, 10]
      },
      {
        min: 10,
        affixes: [10, 9]
      },
      {
        min: 12,
        affixes: [147]
      }
    ],
    blizzardSeasonId: 18,
    isMainSeason: true,
    allowedDungeonPatches: [],
    allowedDungeons: [
      16865, // Altar of Fangs
      16091, // Murder Row
      16368, // Den of Nalorakk
      16425, // Voidscar Arena
      16359, // The Blinding Vale
      9527, // Temple of Sethraliss
      9526, // Kings' Rest
      14063 // Ruby Life Pools
    ],
    supportsWarbands: true,
    supportsAffixes: true,
    supportsSpecs: true,
    supportsFactions: false,
    supportsMixedFactions: true,
    supportsTeams: true,
    supportsWeeklies: true,
    supportsCovenants: false,
    supportsRunRaceAndItemLevel: true,
    supportsScoreStats: true,
    supportsCutoffsPage: true,
    supportsRecruitment: true,
    supportsRouteGeneration: true,
    supportsReplays: true,
    supportsHeatmap: true,
    loadoutFeatures: ['talents_df', 'tier', 'score'],
    partition: {
      type: SeasonPartitionType.LIVE,
      eventId: getSeasonPartitionEventId(17, 0)
    },
    allowedRealmTypes: [RealmConnectionType.LIVE],
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    starts: MIDNIGHT_SEASON2_DATES,
    ends: {
      us: FAR_FUTURE_DATE,
      eu: FAR_FUTURE_DATE,
      tw: FAR_FUTURE_DATE,
      kr: FAR_FUTURE_DATE,
      cn: FAR_FUTURE_DATE
    }
  },
  {
    id: 73,
    slug: 'season-mn-2-tr',
    name: 'Season 2 TR',
    short_name: 'MNTR2',
    scoringSystem: TScoringSystem.V11,
    title: 'MN Season 2 TR',
    expansionId: Expansion.Midnight,
    assetExpansionId: Expansion.Midnight,
    patchId: ExpansionPatch.Patch_1210,
    assetPatchId: ExpansionPatch.Patch_1210,
    skipAffixAlerts: false,
    icon: 'inv_knife_1h_ulatekfang_d_01_poison',
    // NOTE: need to explicitly not include the 12+ range for guile here due
    // to other code not handling it properly
    affixThreshold: [4, 7, 10],
    affixLevelRanges: [
      {
        min: 4,
        max: 11,
        affixes: [148, 158, 160, 162]
      },
      {
        min: 7,
        affixes: [9, 10]
      },
      {
        min: 10,
        affixes: [10, 9]
      },
      {
        min: 12,
        affixes: [147]
      }
    ],
    blizzardSeasonId: 18,
    isMainSeason: false,
    allowedDungeonPatches: [],
    hidden: true,
    allowedDungeons: [
      16865, // Altar of Fangs
      16091, // Murder Row
      16368, // Den of Nalorakk
      16425, // Voidscar Arena
      16359, // The Blinding Vale
      9527, // Temple of Sethraliss
      9526, // Kings' Rest
      14063 // Ruby Life Pools
    ],
    supportsWarbands: false,
    supportsAffixes: false,
    supportsSpecs: true,
    supportsFactions: false,
    supportsMixedFactions: true,
    supportsTeams: true,
    supportsWeeklies: false,
    supportsCovenants: false,
    supportsRunRaceAndItemLevel: true,
    supportsScoreStats: true,
    supportsCutoffsPage: false,
    supportsRecruitment: false,
    supportsRouteGeneration: true,
    supportsReplays: true,
    loadoutFeatures: ['talents_df', 'tier', 'score'],
    partition: {
      type: SeasonPartitionType.TR,
      eventId: getSeasonPartitionEventId(17, 2)
    },
    allowedRealmTypes: [RealmConnectionType.TR],
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    starts: MIDNIGHT_SEASON2_DATES,
    ends: {
      us: FAR_FUTURE_DATE,
      eu: FAR_FUTURE_DATE,
      tw: FAR_FUTURE_DATE,
      kr: FAR_FUTURE_DATE,
      cn: FAR_FUTURE_DATE
    }
  },
  {
    id: 69,
    slug: 'season-mn-1',
    name: 'Season 1',
    short_name: 'MN1',
    scoringSystem: TScoringSystem.V11,
    title: 'MN Season 1',
    expansionId: Expansion.Midnight,
    assetExpansionId: Expansion.Midnight,
    patchId: ExpansionPatch.Patch_1200,
    assetPatchId: ExpansionPatch.Patch_1200,
    skipAffixAlerts: false,
    icon: 'inv_achievement_raid_darkwell',
    // NOTE: need to explicitly not include the 12+ range for guile here due
    // to other code not handling it properly
    affixThreshold: [4, 7, 10],
    affixLevelRanges: [
      {
        min: 4,
        max: 11,
        affixes: [148, 158, 160, 162]
      },
      {
        min: 7,
        affixes: [9, 10]
      },
      {
        min: 10,
        affixes: [10, 9]
      },
      {
        min: 12,
        affixes: [147]
      }
    ],
    blizzardSeasonId: 17,
    isMainSeason: true,
    allowedDungeonPatches: [],
    allowedDungeons: [
      16573, // Nexus-Point Xenas
      16395, // Maisara Caverns
      15829, // Magisters' Terrace
      15808, // Windrunner Spire
      14032, // Algeth'ar Academy
      8910, // Seat of the Triumvirate
      6988, // Skyreach
      4813 // Pit of Saron
    ],
    supportsWarbands: true,
    supportsAffixes: true,
    supportsSpecs: true,
    supportsFactions: false,
    supportsMixedFactions: true,
    supportsTeams: true,
    supportsWeeklies: true,
    supportsCovenants: false,
    supportsRunRaceAndItemLevel: true,
    supportsScoreStats: true,
    supportsCutoffsPage: true,
    supportsRecruitment: true,
    supportsRouteGeneration: true,
    supportsReplays: true,
    supportsHeatmap: true,
    loadoutFeatures: ['talents_df', 'tier', 'score'],
    partition: {
      type: SeasonPartitionType.LIVE,
      eventId: getSeasonPartitionEventId(16, 0)
    },
    allowedRealmTypes: [RealmConnectionType.LIVE],
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    starts: MIDNIGHT_SEASON1_MPLUS_DATES,
    ends: MIDNIGHT_SEASON2_DATES
  },
  {
    id: 71,
    slug: 'season-mn-1-tr',
    name: 'Season 1 TR',
    short_name: 'MNTR1',
    scoringSystem: TScoringSystem.V11,
    title: 'MN Season 1 TR',
    expansionId: Expansion.Midnight,
    assetExpansionId: Expansion.Midnight,
    patchId: ExpansionPatch.Patch_1200,
    assetPatchId: ExpansionPatch.Patch_1200,
    skipAffixAlerts: false,
    icon: 'inv_achievement_raid_darkwell',
    // NOTE: need to explicitly not include the 12+ range for guile here due
    // to other code not handling it properly
    affixThreshold: [4, 7, 10],
    affixLevelRanges: [
      {
        min: 4,
        max: 11,
        affixes: [148, 158, 160, 162]
      },
      {
        min: 7,
        affixes: [9, 10]
      },
      {
        min: 10,
        affixes: [10, 9]
      },
      {
        min: 12,
        affixes: [147]
      }
    ],
    blizzardSeasonId: 17,
    isMainSeason: false,
    allowedDungeonPatches: [],
    hidden: true,
    allowedDungeons: [
      16573, // Nexus-Point Xenas
      16395, // Maisara Caverns
      15829, // Magisters' Terrace
      15808, // Windrunner Spire
      14032, // Algeth'ar Academy
      8910, // Seat of the Triumvirate
      6988, // Skyreach
      4813 // Pit of Saron
    ],
    supportsWarbands: false,
    supportsAffixes: false,
    supportsSpecs: true,
    supportsFactions: false,
    supportsMixedFactions: true,
    supportsTeams: true,
    supportsWeeklies: false,
    supportsCovenants: false,
    supportsRunRaceAndItemLevel: true,
    supportsScoreStats: true,
    supportsCutoffsPage: false,
    supportsRecruitment: false,
    supportsRouteGeneration: true,
    supportsReplays: true,
    loadoutFeatures: ['talents_df', 'tier', 'score'],
    partition: {
      type: SeasonPartitionType.TR,
      eventId: getSeasonPartitionEventId(16, 2)
    },
    allowedRealmTypes: [RealmConnectionType.TR],
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    starts: MIDNIGHT_SEASON1_MPLUS_DATES,
    ends: MIDNIGHT_SEASON2_DATES
  },
  {
    id: 74,
    slug: 'season-mn-2-ptr',
    name: 'Season 2 • PTR',
    short_name: 'MN2PTR',
    scoringSystem: TScoringSystem.V11,
    title: 'MN Season 2 • PTR',
    expansionId: Expansion.Midnight,
    assetExpansionId: Expansion.Midnight,
    patchId: ExpansionPatch.Patch_1210,
    assetPatchId: ExpansionPatch.Patch_1210,
    skipAffixAlerts: true,
    skipSuspiciousChecks: true,
    icon: 'inv_knife_1h_ulatekfang_d_01_poison',
    affixThreshold: [4, 7, 10],
    blizzardSeasonId: 18,
    isMainSeason: false,
    allowedDungeonPatches: [],
    hidden: true,
    allowedDungeons: [
      16865, // Altar of Fangs
      16091, // Murder Row
      16368, // Den of Nalorakk
      16425, // Voidscar Arena
      16359, // The Blinding Vale
      9527, // Temple of Sethraliss
      9526, // Kings' Rest
      14063 // Ruby Life Pools
    ],
    supportsAffixes: false,
    supportsSpecs: true,
    supportsFactions: false,
    supportsMixedFactions: true,
    supportsTeams: true,
    supportsWeeklies: false,
    supportsCovenants: false,
    supportsRunRaceAndItemLevel: true,
    supportsScoreStats: false,
    supportsCutoffsPage: false,
    supportsRecruitment: false,
    supportsRouteGeneration: true,
    supportsReplays: true,
    loadoutFeatures: ['talents_df', 'tier', 'score'],
    partition: {
      type: SeasonPartitionType.PTR,
      eventId: getSeasonPartitionEventId(17, 1)
    },
    allowedRealmTypes: [RealmConnectionType.PTR],
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    starts: {
      us: moment.utc('2026-06-16T15:00:00'),
      eu: moment.utc('2026-06-17T04:00:00'),
      tw: moment.utc('2026-06-17T23:00:00'),
      kr: moment.utc('2026-06-17T23:00:00'),
      cn: moment.utc('2026-06-17T23:00:00')
    },
    ends: MIDNIGHT_SEASON2_DATES
  },
  {
    id: 59,
    slug: 'season-tww-3',
    name: 'Season 3 (Full)',
    short_name: 'TWW3 (Full)',
    scoringSystem: TScoringSystem.V10,
    title: 'TWW Season 3 • With Pre Patch',
    sortWeight: 4,
    expansionId: Expansion.TheWarWithin,
    assetExpansionId: Expansion.TheWarWithin,
    patchId: ExpansionPatch.Patch_1120,
    assetPatchId: ExpansionPatch.Patch_1120,
    skipAffixAlerts: false,
    icon: 'inv_112_achievement_zone_karesh',
    // NOTE: need to explicitly not include the 12+ range for guile here due
    // to other code not handling it properly
    affixThreshold: [4, 7, 10],
    affixLevelRanges: [
      {
        min: 4,
        max: 11,
        affixes: [148, 158, 160, 162]
      },
      {
        min: 7,
        affixes: [9, 10]
      },
      {
        min: 10,
        affixes: [10, 9]
      },
      {
        min: 12,
        affixes: [147]
      }
    ],
    blizzardSeasonId: 15,
    isMainSeason: true,
    allowedDungeonPatches: [],
    allowedDungeons: [
      1000001, // Tazavesh: So'leah's Gambit
      1000000, // Tazavesh: Streets of Wonder
      16104, // Eco-Dome Al'dani
      15452, // Operation: Floodgate
      15093, // "Ara-Kara, City of Echoes"
      14971, // The Dawnbreaker
      14954, // Priory of the Sacred Flame
      12831 // Halls of Atonement
    ],
    supportsWarbands: true,
    supportsAffixes: true,
    supportsSpecs: true,
    supportsFactions: false,
    supportsMixedFactions: true,
    supportsTeams: true,
    supportsWeeklies: true,
    supportsCovenants: false,
    supportsRunRaceAndItemLevel: true,
    supportsScoreStats: true,
    supportsCutoffsPage: false,
    supportsRecruitment: true,
    supportsRouteGeneration: true,
    supportsReplays: true,
    supportsHeatmap: true,
    loadoutFeatures: ['talents_df', 'tier', 'score'],
    partition: {
      type: SeasonPartitionType.LIVE,
      eventId: getSeasonPartitionEventId(15, 0)
    },
    allowedRealmTypes: [RealmConnectionType.LIVE],
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    starts: TWW_SEASON3_DATES,
    ends: MIDNIGHT_GLOBAL_LAUNCH_DATES
  },
  {
    id: 70,
    slug: 'season-tww-3-cutoffs',
    name: 'Season 3',
    short_name: 'TWW3',
    scoringSystem: TScoringSystem.V10,
    sortWeight: 5,
    title: 'TWW Season 3',
    expansionId: Expansion.TheWarWithin,
    assetExpansionId: Expansion.TheWarWithin,
    patchId: ExpansionPatch.Patch_1120,
    assetPatchId: ExpansionPatch.Patch_1120,
    skipAffixAlerts: true,
    icon: 'inv_112_achievement_zone_karesh',
    // NOTE: need to explicitly not include the 12+ range for guile here due
    // to other code not handling it properly
    affixThreshold: [4, 7, 10],
    affixLevelRanges: [
      {
        min: 4,
        max: 11,
        affixes: [148, 158, 160, 162]
      },
      {
        min: 7,
        affixes: [9, 10]
      },
      {
        min: 10,
        affixes: [10, 9]
      },
      {
        min: 12,
        affixes: [147]
      }
    ],
    blizzardSeasonId: 15,
    isMainSeason: false,
    allowedDungeonPatches: [],
    allowedDungeons: [
      1000001, // Tazavesh: So'leah's Gambit
      1000000, // Tazavesh: Streets of Wonder
      16104, // Eco-Dome Al'dani
      15452, // Operation: Floodgate
      15093, // "Ara-Kara, City of Echoes"
      14971, // The Dawnbreaker
      14954, // Priory of the Sacred Flame
      12831 // Halls of Atonement
    ],
    supportsWarbands: false,
    supportsAffixes: true,
    supportsSpecs: true,
    supportsFactions: false,
    supportsMixedFactions: true,
    supportsTeams: false,
    supportsWeeklies: false,
    supportsCovenants: false,
    supportsRunRaceAndItemLevel: true,
    supportsScoreStats: true,
    supportsCutoffsPage: true,
    supportsRecruitment: false,
    supportsRouteGeneration: false,
    supportsReplays: false,
    supportsHeatmap: false,
    loadoutFeatures: ['talents_df', 'tier', 'score'],
    partition: {
      type: SeasonPartitionType.LIVE,
      eventId: getSeasonPartitionEventId(15, 4)
    },
    allowedRealmTypes: [RealmConnectionType.LIVE],
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    starts: TWW_SEASON3_DATES,
    ends: TWW_SEASON3_CUTOFFS_DATES
  },
  {
    id: 68,
    slug: 'season-mn-1-beta',
    name: 'Season 1 Beta',
    short_name: 'MN1BETA',
    scoringSystem: TScoringSystem.V10,
    title: 'TWW Season 1 Beta',
    expansionId: Expansion.Midnight,
    assetExpansionId: Expansion.Midnight,
    patchId: ExpansionPatch.Patch_1200,
    assetPatchId: ExpansionPatch.Patch_1200,
    skipAffixAlerts: true,
    icon: 'inv_achievement_raid_darkwell',
    // NOTE: need to explicitly not include the 12+ range for guile here due
    // to other code not handling it properly
    affixThreshold: [4, 7, 10],
    affixLevelRanges: [
      {
        min: 4,
        max: 11,
        affixes: [148, 158, 160, 162]
      },
      {
        min: 7,
        affixes: [9, 10]
      },
      {
        min: 10,
        affixes: [10, 9]
      },
      {
        min: 12,
        affixes: [147]
      }
    ],
    blizzardSeasonId: 15,
    isMainSeason: false,
    allowedDungeonPatches: [],
    hidden: true,
    allowedDungeons: [
      16573, // Nexus-Point Xenas
      16395, // Maisara Caverns
      15829, // Magisters' Terrace
      15808, // Windrunner Spire
      14032, // Algeth'ar Academy
      8910, // Seat of the Triumvirate
      6988, // Skyreach
      4813 // Pit of Saron
    ],
    supportsWarbands: false,
    supportsAffixes: false,
    supportsSpecs: true,
    supportsFactions: false,
    supportsMixedFactions: true,
    supportsTeams: true,
    supportsWeeklies: false,
    supportsCovenants: false,
    supportsRunRaceAndItemLevel: true,
    supportsScoreStats: true,
    supportsCutoffsPage: false,
    supportsRecruitment: false,
    supportsRouteGeneration: true,
    supportsReplays: true,
    loadoutFeatures: ['talents_df', 'tier', 'score'],
    partition: {
      type: SeasonPartitionType.TR,
      eventId: getSeasonPartitionEventId(16, 1)
    },
    allowedRealmTypes: [RealmConnectionType.BETA],
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    starts: {
      us: moment.utc('2025-11-10T00:00:00'),
      eu: moment.utc('2025-11-10T00:00:00'),
      tw: moment.utc('2025-11-10T00:00:00'),
      kr: moment.utc('2025-11-10T00:00:00'),
      cn: moment.utc('2025-11-10T00:00:00')
    },
    ends: MIDNIGHT_GLOBAL_LAUNCH_DATES
  },
  {
    id: 65,
    slug: 'season-tww-3-legion-remix',
    name: 'Legion Remix',
    short_name: 'TWW3LR',
    scoringSystem: TScoringSystem.V3_LEGION_REMIX,
    title: 'Legion Remix',
    sortWeight: 2,
    expansionId: Expansion.TheWarWithin,
    assetExpansionId: Expansion.Legion,
    patchId: ExpansionPatch.Patch_1120,
    assetPatchId: ExpansionPatch.Patch_700,
    skipAffixAlerts: true,
    icon: 'inv_infernalbrimstone',
    affixThreshold: [2, 4, 7, 10],
    affixLevelRanges: [
      {
        min: 2,
        affixes: [167, 166, 168, 169]
      },
      {
        min: 4,
        affixes: [7, 11, 13, 6, 8, 5]
      },
      {
        min: 7,
        affixes: [14, 2, 3]
      },
      {
        min: 10,
        affixes: [10, 9, 170]
      }
    ],
    blizzardSeasonId: 15,
    isMainSeason: false,
    allowedDungeonPatches: [],
    allowedDungeons: [
      7546, // Neltharion's Lair
      7672, // Halls of Valor
      7673, // Darkheart Thicket
      7787, // Vault of the Wardens
      7805, // Black Rook Hold
      7812, // Maw of Souls
      7855, // The Arcway
      8040, // Eye of Azshara
      8079, // Court of Stars
      8527, // Cathedral of Eternal Night
      8910, // Seat of the Triumvirate
      999998, // Return to Karazhan: Lower
      999999 // Return to Karazhan: Upper
    ],
    supportsWarbands: false,
    supportsAffixes: true,
    supportsSpecs: true,
    supportsFactions: false,
    supportsMixedFactions: true,
    supportsTeams: false,
    supportsWeeklies: true,
    supportsCovenants: false,
    supportsRunRaceAndItemLevel: true,
    supportsScoreStats: true,
    supportsCutoffsPage: true,
    supportsRecruitment: false,
    supportsRouteGeneration: true,
    supportsReplays: true,
    supportsHeatmap: true,
    loadoutFeatures: ['talents_df', 'tier', 'score'],
    partition: {
      type: SeasonPartitionType.REMIX,
      eventId: getSeasonPartitionEventId(15, 3)
    },
    allowedRealmTypes: [RealmConnectionType.LIVE],
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    starts: TWW_SEASON3_LEGION_REMIX_DATES,
    ends: TWW_SEASON3_CUTOFFS_DATES
  },
  {
    id: 66,
    slug: 'season-tww-3-legion-remix-1-player',
    name: 'Legion Remix - 1 Player',
    short_name: 'TWW3LR1P',
    scoringSystem: TScoringSystem.V3_LEGION_REMIX,
    title: 'Legion Remix - 1 Player',
    sortWeight: 1,
    expansionId: Expansion.TheWarWithin,
    assetExpansionId: Expansion.Legion,
    patchId: ExpansionPatch.Patch_1120,
    assetPatchId: ExpansionPatch.Patch_700,
    skipAffixAlerts: true,
    icon: 'inv_infernalbrimstone',
    affixThreshold: [2, 4, 7, 10],
    affixLevelRanges: [
      {
        min: 2,
        affixes: [167, 166, 168, 169]
      },
      {
        min: 4,
        affixes: [7, 11, 13, 6, 8, 5]
      },
      {
        min: 7,
        affixes: [14, 2, 3]
      },
      {
        min: 10,
        affixes: [10, 9, 170]
      }
    ],
    blizzardSeasonId: 15,
    isMainSeason: false,
    allowedDungeonPatches: [],
    allowedDungeons: [
      7546, // Neltharion's Lair
      7672, // Halls of Valor
      7673, // Darkheart Thicket
      7787, // Vault of the Wardens
      7805, // Black Rook Hold
      7812, // Maw of Souls
      7855, // The Arcway
      8040, // Eye of Azshara
      8079, // Court of Stars
      8527, // Cathedral of Eternal Night
      8910, // Seat of the Triumvirate
      999998, // Return to Karazhan: Lower
      999999 // Return to Karazhan: Upper
    ],
    supportsWarbands: false,
    supportsAffixes: true,
    supportsSpecs: true,
    supportsFactions: false,
    supportsMixedFactions: true,
    supportsTeams: false,
    supportsWeeklies: true,
    supportsCovenants: false,
    supportsRunRaceAndItemLevel: true,
    supportsScoreStats: true,
    supportsCutoffsPage: false,
    supportsRecruitment: false,
    supportsRouteGeneration: true,
    supportsReplays: true,
    supportsHeatmap: true,
    loadoutFeatures: ['talents_df', 'tier', 'score'],
    partition: {
      type: SeasonPartitionType.REMIX,
      eventId: 50013
    },
    allowedRealmTypes: [RealmConnectionType.LIVE],
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    starts: TWW_SEASON3_LEGION_REMIX_DATES,
    ends: TWW_SEASON3_CUTOFFS_DATES
  },
  {
    id: 67,
    slug: 'season-tww-3-break-the-meta',
    name: 'TWW Season 3 • Break the Meta',
    short_name: 'BTM TWW3',
    scoringSystem: TScoringSystem.V10,
    title: 'TWW Season 3 • Break the Meta',
    sortWeight: 3,
    expansionId: Expansion.TheWarWithin,
    assetExpansionId: Expansion.TheWarWithin,
    patchId: ExpansionPatch.Patch_1120,
    assetPatchId: ExpansionPatch.Patch_1120,
    skipAffixAlerts: true,
    icon: 'inv_11xp_mdi_banner04',
    // NOTE: need to explicitly not include the 12+ range for guile here due
    // to other code not handling it properly
    affixThreshold: [4, 7, 10],
    affixLevelRanges: [
      {
        min: 4,
        max: 11,
        affixes: [148, 158, 160, 162]
      },
      {
        min: 7,
        affixes: [9, 10]
      },
      {
        min: 10,
        affixes: [10, 9]
      },
      {
        min: 12,
        affixes: [147]
      }
    ],
    blizzardSeasonId: 15,
    isMainSeason: false,
    allowedRealmTypes: [RealmConnectionType.LIVE],
    allowedDungeonPatches: [],
    allowedDungeons: [
      1000001, // Tazavesh: So'leah's Gambit
      1000000, // Tazavesh: Streets of Wonder
      16104, // Eco-Dome Al'dani
      15452, // Operation: Floodgate
      15093, // "Ara-Kara, City of Echoes"
      14971, // The Dawnbreaker
      14954, // Priory of the Sacred Flame
      12831 // Halls of Atonement
    ],
    supportsWarbands: true,
    supportsAffixes: true,
    supportsSpecs: true,
    supportsFactions: false,
    supportsMixedFactions: true,
    supportsTeams: true,
    supportsWeeklies: false, // temp event does not need to store weekly leaderboard
    supportsCovenants: false,
    supportsRunRaceAndItemLevel: true,
    supportsScoreStats: false,
    supportsCutoffsPage: false,
    supportsRecruitment: false,
    supportsRouteGeneration: true,
    supportsReplays: true,
    loadoutFeatures: ['talents_df', 'tier', 'score'],

    partition: {
      type: SeasonPartitionType.LIVE,
      eventId: DYNAMIC_BRACKET_EVENT_START + 296
    },
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,

    starts: {
      us: moment.utc('2025-11-18T15:00:00'),
      eu: moment.utc('2025-11-19T04:00:00'),
      tw: moment.utc('2025-11-19T23:00:00'),
      kr: moment.utc('2025-11-19T23:00:00'),
      cn: moment.utc('2025-11-19T23:00:00')
    },
    ends: {
      us: moment.utc('2025-11-25T15:00:00'),
      eu: moment.utc('2025-11-26T04:00:00'),
      tw: moment.utc('2025-11-26T23:00:00'),
      kr: moment.utc('2025-11-26T23:00:00'),
      cn: moment.utc('2025-11-26T23:00:00')
    }
  },
  {
    id: 61,
    slug: 'season-tww-3-tr',
    name: 'Season 3 TR',
    short_name: 'TWWTR3',
    scoringSystem: TScoringSystem.V10,
    title: 'TWW Season 3 TR',
    expansionId: Expansion.TheWarWithin,
    assetExpansionId: Expansion.TheWarWithin,
    patchId: ExpansionPatch.Patch_1120,
    assetPatchId: ExpansionPatch.Patch_1120,
    skipAffixAlerts: false,
    icon: 'ui_majorfactions_rocket',
    // NOTE: need to explicitly not include the 12+ range for guile here due
    // to other code not handling it properly
    affixThreshold: [4, 7, 10],
    affixLevelRanges: [
      {
        min: 4,
        max: 11,
        affixes: [148, 158, 160, 162]
      },
      {
        min: 7,
        affixes: [9, 10]
      },
      {
        min: 10,
        affixes: [10, 9]
      },
      {
        min: 12,
        affixes: [147]
      }
    ],
    blizzardSeasonId: 15,
    isMainSeason: false,
    allowedDungeonPatches: [],
    hidden: true,
    allowedDungeons: [
      1000001, // Tazavesh: So'leah's Gambit
      1000000, // Tazavesh: Streets of Wonder
      16104, // Eco-Dome Al'dani
      15452, // Operation: Floodgate
      15093, // "Ara-Kara, City of Echoes"
      14971, // The Dawnbreaker
      14954, // Priory of the Sacred Flame
      12831 // Halls of Atonement
    ],
    supportsWarbands: false,
    supportsAffixes: false,
    supportsSpecs: true,
    supportsFactions: false,
    supportsMixedFactions: true,
    supportsTeams: true,
    supportsWeeklies: false,
    supportsCovenants: false,
    supportsRunRaceAndItemLevel: true,
    supportsScoreStats: true,
    supportsCutoffsPage: false,
    supportsRecruitment: false,
    supportsRouteGeneration: true,
    supportsReplays: true,
    loadoutFeatures: ['talents_df', 'tier', 'score'],
    partition: {
      type: SeasonPartitionType.TR,
      eventId: getSeasonPartitionEventId(15, 2)
    },
    allowedRealmTypes: [RealmConnectionType.TR],
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    starts: TWW_SEASON3_DATES,
    ends: MIDNIGHT_GLOBAL_LAUNCH_DATES
  },
  {
    id: 55,
    slug: 'season-tww-2',
    name: 'Season 2',
    short_name: 'TWW2',
    scoringSystem: TScoringSystem.V10,
    title: 'TWW Season 2',
    expansionId: Expansion.TheWarWithin,
    assetExpansionId: Expansion.TheWarWithin,
    patchId: ExpansionPatch.Patch_1110,
    assetPatchId: ExpansionPatch.Patch_1110,
    skipAffixAlerts: false,
    icon: 'ui_majorfactions_rocket',
    // NOTE: need to explicitly not include the 12+ range for guile here due
    // to other code not handling it properly
    affixThreshold: [4, 7, 10],
    affixLevelRanges: [
      {
        min: 4,
        max: 11,
        affixes: [148, 158, 160, 162]
      },
      {
        min: 7,
        affixes: [9, 10]
      },
      {
        min: 10,
        affixes: [10, 9]
      },
      {
        min: 12,
        affixes: [147]
      }
    ],
    blizzardSeasonId: 14,
    isMainSeason: true,
    allowedDungeonPatches: [],
    allowedDungeons: [
      15103, // Cinderbrew Meadery
      14882, // Darkflame Cleft
      14938, // The Rookery
      14954, // Priory of the Sacred Flame
      15452, // Operation: Floodgate
      8064, // The MOTHERLODE!!
      12841, // Theater of Pain
      800002 // Operation: Mechagon: Workshop
    ],
    supportsWarbands: false,
    supportsAffixes: true,
    supportsSpecs: true,
    supportsFactions: false,
    supportsMixedFactions: true,
    supportsTeams: true,
    supportsWeeklies: true,
    supportsCovenants: false,
    supportsRunRaceAndItemLevel: true,
    supportsScoreStats: true,
    supportsCutoffsPage: true,
    supportsRecruitment: true,
    supportsRouteGeneration: true,
    supportsReplays: true,
    supportsHeatmap: true,
    loadoutFeatures: ['talents_df', 'tier', 'score'],
    partition: {
      type: SeasonPartitionType.LIVE,
      eventId: getSeasonPartitionEventId(14, 0)
    },
    allowedRealmTypes: [RealmConnectionType.LIVE],
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    starts: TWW_SEASON2_DATES,
    ends: TWW_SEASON3_DATES
  },
  {
    id: 62,
    sortWeight: 2,
    slug: 'season-tww-2-break-the-meta',
    name: 'TWW Season 2 • Break the Meta',
    short_name: 'BTM TWW2',
    scoringSystem: TScoringSystem.V10,
    title: 'TWW Season 2 • Break the Meta',
    expansionId: Expansion.TheWarWithin,
    assetExpansionId: Expansion.TheWarWithin,
    patchId: ExpansionPatch.Patch_1110,
    assetPatchId: ExpansionPatch.Patch_1110,
    skipAffixAlerts: true,
    icon: 'inv_11xp_mdi_banner04',
    // NOTE: need to explicitly not include the 12+ range for guile here due
    // to other code not handling it properly
    affixThreshold: [4, 7, 10],
    affixLevelRanges: [
      {
        min: 4,
        max: 11,
        affixes: [148, 158, 160, 162]
      },
      {
        min: 7,
        affixes: [9, 10]
      },
      {
        min: 10,
        affixes: [10, 9]
      },
      {
        min: 12,
        affixes: [147]
      }
    ],
    blizzardSeasonId: 14,
    isMainSeason: false,
    allowedRealmTypes: [RealmConnectionType.LIVE],
    allowedDungeonPatches: [],
    allowedDungeons: [
      15103, // Cinderbrew Meadery
      14882, // Darkflame Cleft
      14938, // The Rookery
      14954, // Priory of the Sacred Flame
      15452, // Operation: Floodgate
      8064, // The MOTHERLODE!!
      12841, // Theater of Pain
      800002 // Operation: Mechagon: Workshop
    ],
    supportsAffixes: true,
    supportsSpecs: true,
    supportsFactions: false,
    supportsMixedFactions: true,
    supportsTeams: true,
    supportsWeeklies: false, // temp event does not need to store weekly leaderboard
    supportsCovenants: false,
    supportsRunRaceAndItemLevel: true,
    supportsScoreStats: false,
    supportsCutoffsPage: false,
    supportsRecruitment: false,
    supportsRouteGeneration: true,
    supportsReplays: true,
    loadoutFeatures: ['talents_df', 'tier', 'score'],
    partition: {
      type: SeasonPartitionType.LIVE,
      eventId: DYNAMIC_BRACKET_EVENT_START + 242
    },
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    starts: {
      us: moment.utc('2025-06-24T15:00:00'),
      eu: moment.utc('2025-06-25T04:00:00'),
      tw: moment.utc('2025-06-25T23:00:00'),
      kr: moment.utc('2025-06-25T23:00:00'),
      cn: moment.utc('2025-06-25T23:00:00')
    },
    ends: {
      us: moment.utc('2025-07-01T15:00:00'),
      eu: moment.utc('2025-07-02T04:00:00'),
      tw: moment.utc('2025-07-02T23:00:00'),
      kr: moment.utc('2025-07-02T23:00:00'),
      cn: moment.utc('2025-07-02T23:00:00')
    }
  },
  {
    id: 63,
    sortWeight: 2,
    slug: 'season-tww-2-meta-vs-meta',
    name: 'TWW Season 2 • Meta Vs Meta',
    short_name: 'MVM TWW2',
    scoringSystem: TScoringSystem.V10,
    title: 'TWW Season 2 • Meta Vs Meta',
    expansionId: Expansion.TheWarWithin,
    assetExpansionId: Expansion.TheWarWithin,
    patchId: ExpansionPatch.Patch_1110,
    assetPatchId: ExpansionPatch.Patch_1110,
    skipAffixAlerts: true,
    icon: 'inv_11xp_mdi_banner04',
    // NOTE: need to explicitly not include the 12+ range for guile here due
    // to other code not handling it properly
    affixThreshold: [4, 7, 10],
    affixLevelRanges: [
      {
        min: 4,
        max: 11,
        affixes: [148, 158, 160, 162]
      },
      {
        min: 7,
        affixes: [9, 10]
      },
      {
        min: 10,
        affixes: [10, 9]
      },
      {
        min: 12,
        affixes: [147]
      }
    ],
    blizzardSeasonId: 14,
    isMainSeason: false,
    allowedRealmTypes: [RealmConnectionType.LIVE],
    allowedDungeonPatches: [],
    allowedDungeons: [
      15103, // Cinderbrew Meadery
      14882, // Darkflame Cleft
      14938, // The Rookery
      14954, // Priory of the Sacred Flame
      15452, // Operation: Floodgate
      8064, // The MOTHERLODE!!
      12841, // Theater of Pain
      800002 // Operation: Mechagon: Workshop
    ],
    supportsAffixes: true,
    supportsSpecs: true,
    supportsFactions: false,
    supportsMixedFactions: true,
    supportsTeams: true,
    supportsWeeklies: false, // temp event does not need to store weekly leaderboard
    supportsCovenants: false,
    supportsRunRaceAndItemLevel: true,
    supportsScoreStats: false,
    supportsCutoffsPage: false,
    supportsRecruitment: false,
    supportsRouteGeneration: true,
    supportsReplays: true,
    loadoutFeatures: ['talents_df', 'tier', 'score'],
    partition: {
      type: SeasonPartitionType.LIVE,
      eventId: DYNAMIC_BRACKET_EVENT_START + 243
    },
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    starts: {
      us: moment.utc('2025-06-24T15:00:00'),
      eu: moment.utc('2025-06-25T04:00:00'),
      tw: moment.utc('2025-06-25T23:00:00'),
      kr: moment.utc('2025-06-25T23:00:00'),
      cn: moment.utc('2025-06-25T23:00:00')
    },
    ends: {
      us: moment.utc('2025-07-01T15:00:00'),
      eu: moment.utc('2025-07-02T04:00:00'),
      tw: moment.utc('2025-07-02T23:00:00'),
      kr: moment.utc('2025-07-02T23:00:00'),
      cn: moment.utc('2025-07-02T23:00:00')
    }
  },

  {
    id: 58,
    slug: 'season-tww-2-tr',
    name: 'Season 2 TR',
    short_name: 'TWWTR2',
    scoringSystem: TScoringSystem.V10,
    title: 'TWW Season 2 TR',
    expansionId: Expansion.TheWarWithin,
    assetExpansionId: Expansion.TheWarWithin,
    patchId: ExpansionPatch.Patch_1110,
    assetPatchId: ExpansionPatch.Patch_1110,
    skipAffixAlerts: false,
    icon: 'ui_majorfactions_rocket',
    // NOTE: need to explicitly not include the 12+ range for guile here due
    // to other code not handling it properly
    affixThreshold: [4, 7, 10],
    affixLevelRanges: [
      {
        min: 4,
        max: 11,
        affixes: [148, 158, 160, 162]
      },
      {
        min: 7,
        affixes: [9, 10]
      },
      {
        min: 10,
        affixes: [10, 9]
      },
      {
        min: 12,
        affixes: [147]
      }
    ],
    blizzardSeasonId: 14,
    isMainSeason: false,
    allowedDungeonPatches: [],
    hidden: true,
    allowedDungeons: [
      15103, // Cinderbrew Meadery
      14882, // Darkflame Cleft
      14938, // The Rookery
      14954, // Priory of the Sacred Flame
      15452, // Operation: Floodgate
      8064, // The MOTHERLODE!!
      12841, // Theater of Pain
      800002 // Operation: Mechagon: Workshop
    ],
    supportsWarbands: false,
    supportsAffixes: false,
    supportsSpecs: true,
    supportsFactions: false,
    supportsMixedFactions: true,
    supportsTeams: true,
    supportsWeeklies: false,
    supportsCovenants: false,
    supportsRunRaceAndItemLevel: true,
    supportsScoreStats: true,
    supportsCutoffsPage: false,
    supportsRecruitment: false,
    supportsRouteGeneration: true,
    supportsReplays: true,
    loadoutFeatures: ['talents_df', 'tier', 'score'],
    partition: {
      type: SeasonPartitionType.TR,
      eventId: getSeasonPartitionEventId(14, 2)
    },
    allowedRealmTypes: [RealmConnectionType.TR],
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    starts: TWW_SEASON2_DATES,
    ends: TWW_SEASON3_DATES
  },
  {
    id: 47,
    slug: 'season-tww-1',
    name: 'Season 1',
    short_name: 'TWW1',
    scoringSystem: TScoringSystem.V9,
    title: 'TWW Season 1',
    expansionId: Expansion.TheWarWithin,
    assetExpansionId: Expansion.TheWarWithin,
    patchId: ExpansionPatch.Patch_1100,
    assetPatchId: ExpansionPatch.Patch_1100,
    skipAffixAlerts: false,
    icon: 'inv_ability_voidweaverpriest_entropicrift',
    // NOTE: need to explicitly not include the 12+ range for guile here due
    // to other code not handling it properly
    affixThreshold: [2, 4, 7, 10],
    affixLevelRanges: [
      {
        min: 2,
        max: 11,
        affixes: [148, 158, 159, 160]
      },
      {
        min: 4,
        affixes: [9, 10]
      },
      {
        min: 7,
        affixes: [152]
      },
      {
        min: 10,
        affixes: [10, 9]
      },
      {
        min: 12,
        affixes: [147]
      }
    ],
    blizzardSeasonId: 13,
    isMainSeason: true,
    allowedDungeonPatches: [],
    allowedDungeons: [
      15093, // Ara-Kara, City of Echoes
      14979, // City of Threads
      14883, // The Stonevault
      14971, // The Dawnbreaker
      13334, // Mists of Tirna Scithe
      12916, // The Necrotic Wake
      9354, // Siege of Boralus
      4950 // Grim Batol
    ],
    supportsWarbands: false,
    supportsAffixes: true,
    supportsSpecs: true,
    supportsFactions: false,
    supportsMixedFactions: true,
    supportsTeams: true,
    supportsWeeklies: true,
    supportsCovenants: false,
    supportsRunRaceAndItemLevel: true,
    supportsScoreStats: true,
    supportsCutoffsPage: false,
    supportsRecruitment: true,
    supportsRouteGeneration: true,
    supportsReplays: true,
    supportsHeatmap: true,
    loadoutFeatures: ['talents_df', 'tier', 'score'],
    partition: {
      type: SeasonPartitionType.LIVE,
      eventId: getSeasonPartitionEventId(13, 0)
    },
    allowedRealmTypes: [RealmConnectionType.LIVE],
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    starts: TWW_SEASON1_MPLUS_DATES,
    ends: {
      us: moment.utc('2025-02-25T15:00:00'),
      eu: moment.utc('2025-02-26T04:00:00'),
      tw: moment.utc('2025-02-26T23:00:00'),
      kr: moment.utc('2025-02-26T23:00:00'),
      cn: moment.utc('2025-02-26T23:00:00')
    }
  },
  {
    id: 60,
    slug: 'season-tww-3-ptr',
    name: 'Season 3 • PTR',
    short_name: 'TWW3PTR',
    scoringSystem: TScoringSystem.V10,
    title: 'TWW Season 3 • PTR',
    expansionId: Expansion.TheWarWithin,
    assetExpansionId: Expansion.TheWarWithin,
    patchId: ExpansionPatch.Patch_1120,
    assetPatchId: ExpansionPatch.Patch_1120,
    skipAffixAlerts: true,
    skipSuspiciousChecks: true,
    icon: 'inv_112_achievement_zone_karesh',
    affixThreshold: [4, 7, 10],
    blizzardSeasonId: 15,
    isMainSeason: false,
    allowedDungeonPatches: [],
    hidden: true,
    allowedDungeons: [
      1000001, // Tazavesh: So'leah's Gambit
      1000000, // Tazavesh: Streets of Wonder
      16104, // Eco-Dome Al'dani
      15452, // Operation: Floodgate
      15093, // "Ara-Kara, City of Echoes"
      14971, // The Dawnbreaker
      14954, // Priory of the Sacred Flame
      12831 // Halls of Atonement
    ],
    supportsAffixes: false,
    supportsSpecs: true,
    supportsFactions: false,
    supportsMixedFactions: true,
    supportsTeams: true,
    supportsWeeklies: false,
    supportsCovenants: false,
    supportsRunRaceAndItemLevel: true,
    supportsScoreStats: false,
    supportsCutoffsPage: false,
    supportsRecruitment: false,
    supportsRouteGeneration: true,
    supportsReplays: true,
    loadoutFeatures: ['talents_df', 'tier', 'score'],
    allowedRealmTypes: [RealmConnectionType.PTR],
    partition: {
      type: SeasonPartitionType.PTR,
      eventId: getSeasonPartitionEventId(15, 1)
    },
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    starts: {
      us: moment.utc('2025-06-17T15:00:00'),
      eu: moment.utc('2025-06-18T04:00:00'),
      tw: moment.utc('2025-06-18T23:00:00'),
      kr: moment.utc('2025-06-18T23:00:00'),
      cn: moment.utc('2025-06-18T23:00:00')
    },
    ends: TWW_SEASON3_DATES
  },
  {
    id: 57,
    sortWeight: 3,
    slug: 'season-tww-1-post',
    name: 'Season 1 • Post',
    short_name: 'TWW1 (Post)',
    scoringSystem: TScoringSystem.V9,
    title: 'TWW Season 1 • Post',
    hidden: false,
    expansionId: Expansion.TheWarWithin,
    assetExpansionId: Expansion.TheWarWithin,
    patchId: ExpansionPatch.Patch_1110,
    assetPatchId: ExpansionPatch.Patch_1100,
    skipAffixAlerts: true,
    icon: 'inv_ability_voidweaverpriest_entropicrift',
    // NOTE: need to explicitly not include the 12+ range for guile here due
    // to other code not handling it properly
    affixThreshold: [2, 4, 7, 10],
    affixLevelRanges: [
      {
        min: 2,
        max: 11,
        affixes: [148, 158, 159, 160]
      },
      {
        min: 4,
        affixes: [9, 10]
      },
      {
        min: 7,
        affixes: [152]
      },
      {
        min: 10,
        affixes: [10, 9]
      },
      {
        min: 12,
        affixes: [147]
      }
    ],
    blizzardSeasonId: 13,
    isMainSeason: true,
    allowedDungeonPatches: [],
    allowedDungeons: [
      15093, // Ara-Kara, City of Echoes
      14979, // City of Threads
      14883, // The Stonevault
      14971, // The Dawnbreaker
      13334, // Mists of Tirna Scithe
      12916, // The Necrotic Wake
      9354, // Siege of Boralus
      4950 // Grim Batol
    ],
    supportsWarbands: false,
    supportsAffixes: false,
    supportsSpecs: false,
    supportsFactions: false,
    supportsMixedFactions: true,
    supportsTeams: false,
    supportsWeeklies: false,
    supportsCovenants: false,
    supportsRunRaceAndItemLevel: true,
    supportsScoreStats: true,
    supportsCutoffsPage: false,
    supportsRecruitment: false,
    supportsRouteGeneration: false,
    supportsReplays: false,
    supportsHeatmap: false,
    skipLeaderboards: false,
    loadoutFeatures: ['talents_df', 'tier', 'score'],
    partition: {
      type: SeasonPartitionType.LIVE,
      eventId: getSeasonPartitionEventId(13, 4)
    },
    allowedRealmTypes: [RealmConnectionType.LIVE],
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    starts: {
      us: moment.utc('2025-02-25T15:00:00'),
      eu: moment.utc('2025-02-26T04:00:00'),
      tw: moment.utc('2025-02-26T23:00:00'),
      kr: moment.utc('2025-02-26T23:00:00'),
      cn: moment.utc('2025-02-26T23:00:00')
    },
    ends: {
      us: moment.utc('2025-03-04T15:00:00'),
      eu: moment.utc('2025-03-05T04:00:00'),
      tw: moment.utc('2025-03-05T23:00:00'),
      kr: moment.utc('2025-03-05T23:00:00'),
      cn: moment.utc('2025-03-05T23:00:00')
    }
  },
  {
    id: 56,
    slug: 'season-tww-1-cutoffs',
    name: 'Season 1 • Cutoffs',
    short_name: 'TWW1 (Cutoffs)',
    scoringSystem: TScoringSystem.V9,
    title: 'TWW Season 1 • Cutoffs',
    hidden: true,
    expansionId: Expansion.TheWarWithin,
    assetExpansionId: Expansion.TheWarWithin,
    patchId: ExpansionPatch.Patch_1100,
    assetPatchId: ExpansionPatch.Patch_1100,
    skipAffixAlerts: true,
    icon: 'inv_ability_voidweaverpriest_entropicrift',
    // NOTE: need to explicitly not include the 12+ range for guile here due
    // to other code not handling it properly
    affixThreshold: [2, 4, 7, 10],
    affixLevelRanges: [
      {
        min: 2,
        max: 11,
        affixes: [148, 158, 159, 160]
      },
      {
        min: 4,
        affixes: [9, 10]
      },
      {
        min: 7,
        affixes: [152]
      },
      {
        min: 10,
        affixes: [10, 9]
      },
      {
        min: 12,
        affixes: [147]
      }
    ],
    blizzardSeasonId: 13,
    isMainSeason: false,
    allowedDungeonPatches: [],
    allowedDungeons: [
      15093, // Ara-Kara, City of Echoes
      14979, // City of Threads
      14883, // The Stonevault
      14971, // The Dawnbreaker
      13334, // Mists of Tirna Scithe
      12916, // The Necrotic Wake
      9354, // Siege of Boralus
      4950 // Grim Batol
    ],
    supportsWarbands: false,
    supportsAffixes: false,
    supportsSpecs: false,
    supportsFactions: false,
    supportsMixedFactions: true,
    supportsTeams: false,
    supportsWeeklies: false,
    supportsCovenants: false,
    supportsRunRaceAndItemLevel: true,
    supportsScoreStats: true,
    supportsCutoffsPage: true,
    supportsRecruitment: false,
    supportsRouteGeneration: false,
    supportsReplays: false,
    supportsHeatmap: false,
    skipLeaderboards: true,
    loadoutFeatures: ['talents_df', 'tier', 'score'],
    partition: {
      type: SeasonPartitionType.LIVE,
      eventId: getSeasonPartitionEventId(13, 3)
    },
    allowedRealmTypes: [RealmConnectionType.LIVE],
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    starts: TWW_SEASON1_MPLUS_DATES,
    ends: {
      us: moment.utc('2025-02-25T15:00:00'),
      eu: moment.utc('2025-02-26T04:00:00'),
      tw: moment.utc('2025-02-26T23:00:00'),
      kr: moment.utc('2025-02-26T23:00:00'),
      cn: moment.utc('2025-02-26T23:00:00')
    }
  },
  {
    id: 53,
    sortWeight: 2,
    slug: 'season-tww-1-break-the-meta',
    name: 'TWW Season 1 • Break the Meta',
    short_name: 'BTM TWW1',
    scoringSystem: TScoringSystem.V9,
    title: 'TWW Season 1 • Break the Meta',
    icon: 'inv_11xp_mdi_banner01',
    expansionId: Expansion.TheWarWithin,
    assetExpansionId: Expansion.TheWarWithin,
    patchId: ExpansionPatch.Patch_1100,
    assetPatchId: ExpansionPatch.Patch_1100,
    skipAffixAlerts: true,
    affixThreshold: [2, 4, 7, 10],
    affixLevelRanges: [
      {
        min: 2,
        max: 11,
        affixes: [148, 158, 159, 160]
      },
      {
        min: 4,
        affixes: [9, 10]
      },
      {
        min: 7,
        affixes: [152]
      },
      {
        min: 10,
        affixes: [10, 9]
      },
      {
        min: 12,
        affixes: [147]
      }
    ],
    blizzardSeasonId: 13,
    isMainSeason: false,
    allowedRealmTypes: [RealmConnectionType.LIVE],
    allowedDungeonPatches: [],
    allowedDungeons: [
      15093, // Ara-Kara, City of Echoes
      14979, // City of Threads
      14883, // The Stonevault
      14971, // The Dawnbreaker
      13334, // Mists of Tirna Scithe
      12916, // The Necrotic Wake
      9354, // Siege of Boralus
      4950 // Grim Batol
    ],
    supportsAffixes: true,
    supportsSpecs: true,
    supportsFactions: false,
    supportsMixedFactions: true,
    supportsTeams: true,
    supportsWeeklies: false, // temp event does not need to store weekly leaderboard
    supportsCovenants: false,
    supportsRunRaceAndItemLevel: true,
    supportsScoreStats: false,
    supportsCutoffsPage: false,
    supportsRecruitment: false,
    supportsRouteGeneration: true,
    supportsReplays: true,
    loadoutFeatures: ['talents_df', 'tier', 'score'],
    partition: {
      type: SeasonPartitionType.LIVE,
      // 57 is the bracketId used to create the event id on production. This is a hack to connect a bracket to a season for certain events such as BTM.
      eventId: DYNAMIC_BRACKET_EVENT_START + 175
    },
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    starts: {
      us: moment.utc('2024-12-10T15:00:00'),
      eu: moment.utc('2024-12-11T04:00:00'),
      tw: moment.utc('2024-12-11T23:00:00'),
      kr: moment.utc('2024-12-11T23:00:00'),
      cn: moment.utc('2024-12-11T23:00:00')
    },
    ends: {
      us: moment.utc('2024-12-17T15:00:00'),
      eu: moment.utc('2024-12-18T04:00:00'),
      tw: moment.utc('2024-12-18T23:00:00'),
      kr: moment.utc('2024-12-18T23:00:00'),
      cn: moment.utc('2024-12-18T23:00:00')
    }
  },
  {
    id: 52,
    slug: 'season-tww-1-tr',
    name: 'Season 1 TR',
    short_name: 'TWWTR1',
    scoringSystem: TScoringSystem.V9,
    title: 'TWW Season 1 TR',
    expansionId: Expansion.TheWarWithin,
    assetExpansionId: Expansion.TheWarWithin,
    patchId: ExpansionPatch.Patch_1100,
    assetPatchId: ExpansionPatch.Patch_1100,
    skipAffixAlerts: false,
    icon: 'inv_ability_voidweaverpriest_entropicrift',
    // NOTE: need to explicitly not include the 12+ range for guile here due
    // to other code not handling it properly
    affixThreshold: [2, 4, 7, 10],
    affixLevelRanges: [
      {
        min: 2,
        max: 11,
        affixes: [148, 158, 159, 160]
      },
      {
        min: 4,
        affixes: [9, 10]
      },
      {
        min: 7,
        affixes: [152]
      },
      {
        min: 10,
        affixes: [10, 9]
      },
      {
        min: 12,
        affixes: [147]
      }
    ],
    blizzardSeasonId: 13,
    isMainSeason: false,
    allowedDungeonPatches: [],
    hidden: true,
    allowedDungeons: [
      15093, // Ara-Kara, City of Echoes
      14979, // City of Threads
      14883, // The Stonevault
      14971, // The Dawnbreaker
      13334, // Mists of Tirna Scithe
      12916, // The Necrotic Wake
      9354, // Siege of Boralus
      4950 // Grim Batol
    ],
    supportsWarbands: false,
    supportsAffixes: false,
    supportsSpecs: true,
    supportsFactions: false,
    supportsMixedFactions: true,
    supportsTeams: true,
    supportsWeeklies: false,
    supportsCovenants: false,
    supportsRunRaceAndItemLevel: true,
    supportsScoreStats: true,
    supportsCutoffsPage: false,
    supportsRecruitment: false,
    supportsRouteGeneration: true,
    supportsReplays: true,
    loadoutFeatures: ['talents_df', 'tier', 'score'],
    partition: {
      type: SeasonPartitionType.TR,
      eventId: getSeasonPartitionEventId(13, 2)
    },
    allowedRealmTypes: [RealmConnectionType.TR],
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    starts: TWW_SEASON1_MPLUS_DATES,
    ends: {
      us: moment.utc('2025-02-25T15:00:00'),
      eu: moment.utc('2025-02-26T04:00:00'),
      tw: moment.utc('2025-02-26T23:00:00'),
      kr: moment.utc('2025-02-26T23:00:00'),
      cn: moment.utc('2025-02-26T23:00:00')
    }
  },
  {
    id: 54,
    slug: 'season-tww-2-ptr',
    name: 'Season 2 • PTR',
    short_name: 'TWW2PTR',
    scoringSystem: TScoringSystem.V10,
    title: 'TWW Season 2 • PTR',
    expansionId: Expansion.TheWarWithin,
    assetExpansionId: Expansion.TheWarWithin,
    patchId: ExpansionPatch.Patch_1110,
    assetPatchId: ExpansionPatch.Patch_1110,
    hidden: true,
    skipAffixAlerts: true,
    skipSuspiciousChecks: true,
    icon: 'ui_majorfactions_rocket',
    affixThreshold: [4, 7, 10],
    blizzardSeasonId: 14,
    isMainSeason: false,
    allowedDungeonPatches: [],
    allowedDungeons: [
      15103, // Cinderbrew Meadery
      14882, // Darkflame Cleft
      14938, // The Rookery
      14954, // Priory of the Sacred Flame
      15452, // Operation: Floodgate
      8064, // The MOTHERLODE!!
      12841, // Theater of Pain
      800002 // Operation: Mechagon: Workshop
    ],
    supportsAffixes: false,
    supportsSpecs: true,
    supportsFactions: false,
    supportsMixedFactions: true,
    supportsTeams: true,
    supportsWeeklies: false,
    supportsCovenants: false,
    supportsRunRaceAndItemLevel: true,
    supportsScoreStats: false,
    supportsCutoffsPage: false,
    supportsRecruitment: false,
    supportsRouteGeneration: true,
    supportsReplays: true,
    loadoutFeatures: ['talents_df', 'tier', 'score'],
    allowedRealmTypes: [RealmConnectionType.PTR],
    partition: {
      type: SeasonPartitionType.PTR,
      eventId: getSeasonPartitionEventId(14, 1)
    },
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    starts: {
      us: moment.utc('2025-01-07T15:00:00'),
      eu: moment.utc('2025-01-08T04:00:00'),
      tw: moment.utc('2025-01-08T23:00:00'),
      kr: moment.utc('2025-01-08T23:00:00'),
      cn: moment.utc('2025-01-08T23:00:00')
    },
    ends: TWW_SEASON2_DATES
  },
  {
    id: 44,
    sortWeight: 3,
    slug: 'season-df-4',
    name: 'Season 4',
    short_name: 'DF4 (Full)',
    scoringSystem: TScoringSystem.V7,
    title: 'DF Season 4 • With Pre Patch',
    expansionId: Expansion.Dragonflight,
    assetExpansionId: Expansion.Dragonflight,
    patchId: ExpansionPatch.Patch_1026,
    assetPatchId: ExpansionPatch.Patch_1026,
    skipAffixAlerts: false,
    icon: 'inv_10_enchanting2_elementalswirl_color1',
    affixThreshold: [2, 5, 10],
    blizzardSeasonId: 12,
    isMainSeason: true,
    allowedDungeonPatches: [],
    allowedDungeons: [
      14063, // Ruby Life Pools
      14032, // Algeth'ar Academy
      13982, // Nokhud Offensive
      13954, // Azure Vault
      14082, // Halls of Infusion
      13991, // Brackenhide Hollow
      13968, // Uldaman: Legacy of Tyr
      14011 // Neltharus
    ],
    supportsWarbands: false,
    supportsAffixes: true,
    supportsSpecs: true,
    supportsFactions: false,
    supportsMixedFactions: true,
    supportsTeams: true,
    supportsWeeklies: true,
    supportsCovenants: false,
    supportsRunRaceAndItemLevel: true,
    supportsScoreStats: true,
    supportsCutoffsPage: false,
    supportsRecruitment: true,
    supportsRouteGeneration: true,
    supportsReplays: true,
    loadoutFeatures: ['talents_df', 'tier', 'score'],
    partition: {
      type: SeasonPartitionType.LIVE,
      eventId: getSeasonPartitionEventId(12, 0)
    },
    allowedRealmTypes: [RealmConnectionType.LIVE],
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    starts: DF_SEASON4_DATES,
    ends: TWW_GLOBAL_LAUNCH_DATES
  },
  {
    id: 49,
    sortWeight: 2,
    slug: 'season-df-4-post',
    name: 'DF Season 4 • Only Pre Patch',
    short_name: 'DF4 (Post)',
    scoringSystem: TScoringSystem.V7,
    title: 'DF Season 4 • Post',
    affixThreshold: [2, 5, 10],
    icon: 'inv_10_enchanting2_elementalswirl_color1',
    expansionId: Expansion.Dragonflight,
    assetExpansionId: Expansion.Dragonflight,
    patchId: ExpansionPatch.Patch_1026,
    assetPatchId: ExpansionPatch.Patch_1026,
    skipAffixAlerts: true,
    blizzardSeasonId: 12,
    isMainSeason: false,
    allowedDungeonPatches: [],
    allowedDungeons: [
      14063, // Ruby Life Pools
      14032, // Algeth'ar Academy
      13982, // Nokhud Offensive
      13954, // Azure Vault
      14082, // Halls of Infusion
      13991, // Brackenhide Hollow
      13968, // Uldaman: Legacy of Tyr
      14011 // Neltharus
    ],
    supportsSpecs: true,
    supportsAffixes: true,
    supportsFactions: false,
    supportsMixedFactions: true,
    supportsTeams: true,
    supportsWeeklies: false,
    supportsCovenants: false,
    supportsRunRaceAndItemLevel: true,
    supportsScoreStats: true,
    supportsCutoffsPage: false,
    supportsRecruitment: false,
    supportsRouteGeneration: true,
    allowedRealmTypes: [RealmConnectionType.LIVE],
    loadoutFeatures: ['talents_df', 'tier', 'score'],
    partition: {
      type: SeasonPartitionType.LIVE,
      eventId: getSeasonPartitionEventId(12, 3)
    },
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    starts: TWW_PREPATCH_LAUNCH_DATES,
    ends: TWW_GLOBAL_LAUNCH_DATES
  },
  {
    id: 50,
    sortWeight: 4,
    slug: 'season-df-4-cutoffs',
    name: 'DF Season 4',
    short_name: 'DF4',
    scoringSystem: TScoringSystem.V7,
    title: 'DF Season 4',
    affixThreshold: [2, 7, 14],
    icon: 'inv_10_enchanting2_elementalswirl_color1',
    hidden: false,
    expansionId: Expansion.Dragonflight,
    assetExpansionId: Expansion.Dragonflight,
    patchId: ExpansionPatch.Patch_1026,
    assetPatchId: ExpansionPatch.Patch_1026,
    skipAffixAlerts: true,
    skipLeaderboards: false,
    blizzardSeasonId: 12,
    isMainSeason: false,
    allowedDungeonPatches: [],
    allowedDungeons: [
      14063, // Ruby Life Pools
      14032, // Algeth'ar Academy
      13982, // Nokhud Offensive
      13954, // Azure Vault
      14082, // Halls of Infusion
      13991, // Brackenhide Hollow
      13968, // Uldaman: Legacy of Tyr
      14011 // Neltharus
    ],
    supportsAffixes: true,
    supportsSpecs: true,
    supportsFactions: false,
    supportsMixedFactions: true,
    supportsTeams: true,
    supportsWeeklies: false,
    supportsCovenants: false,
    supportsRunRaceAndItemLevel: true,
    supportsScoreStats: true,
    supportsCutoffsPage: true,
    supportsRecruitment: false,
    supportsRouteGeneration: true,
    allowedRealmTypes: [RealmConnectionType.LIVE],
    loadoutFeatures: ['talents_df', 'tier', 'score'],
    partition: {
      type: SeasonPartitionType.LIVE,
      eventId: getSeasonPartitionEventId(12, 4)
    },
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    starts: DF_SEASON4_DATES,
    ends: TWW_PREPATCH_LAUNCH_DATES
  },
  {
    id: 51,
    sortWeight: 1,
    slug: 'season-df-4-break-the-meta',
    name: 'DF Season 4 • Break the Meta',
    short_name: 'BTM DF4',
    scoringSystem: TScoringSystem.V7,
    title: 'DF Season 4 • Break the Meta',
    affixThreshold: [2, 5, 10],
    icon: 'inv_mdi_awc_bannerreward_icons_red',
    expansionId: Expansion.Dragonflight,
    assetExpansionId: Expansion.Dragonflight,
    patchId: ExpansionPatch.Patch_1026,
    assetPatchId: ExpansionPatch.Patch_1026,
    skipAffixAlerts: true,
    blizzardSeasonId: 12,
    isMainSeason: false,
    allowedRealmTypes: [RealmConnectionType.LIVE],
    allowedDungeonPatches: [],
    allowedDungeons: [
      14063, // Ruby Life Pools
      14032, // Algeth'ar Academy
      13982, // Nokhud Offensive
      13954, // Azure Vault
      14082, // Halls of Infusion
      13991, // Brackenhide Hollow
      13968, // Uldaman: Legacy of Tyr
      14011 // Neltharus
    ],
    supportsAffixes: true,
    supportsSpecs: true,
    supportsFactions: false,
    supportsMixedFactions: true,
    supportsTeams: true,
    supportsWeeklies: false, // temp event does not need to store weekly leaderboard
    supportsCovenants: false,
    supportsRunRaceAndItemLevel: true,
    supportsScoreStats: false,
    supportsCutoffsPage: false,
    supportsRecruitment: false,
    supportsRouteGeneration: true,
    supportsReplays: true,
    loadoutFeatures: ['talents_df', 'tier', 'score'],
    partition: {
      type: SeasonPartitionType.LIVE,
      // 57 is the bracketId used to create the event id on production. This is a hack to connect a bracket to a season for certain events such as BTM.
      eventId: DYNAMIC_BRACKET_EVENT_START + 104
    },
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    starts: {
      us: moment.utc('2024-08-06T15:00:00'),
      eu: moment.utc('2024-08-07T04:00:00'),
      tw: moment.utc('2024-08-07T23:00:00'),
      kr: moment.utc('2024-08-07T23:00:00'),
      cn: moment.utc('2024-08-07T23:00:00')
    },
    ends: {
      us: moment.utc('2024-08-13T15:00:00'),
      eu: moment.utc('2024-08-14T04:00:00'),
      tw: moment.utc('2024-08-14T23:00:00'),
      kr: moment.utc('2024-08-14T23:00:00'),
      cn: moment.utc('2024-08-14T23:00:00')
    }
  },
  {
    id: 48,
    sortWeight: 1,
    slug: 'season-tww-1-beta',
    name: 'Season 1 • Beta',
    short_name: 'TWW1BETA',
    scoringSystem: TScoringSystem.V9,
    hidden: true,
    title: 'TWW Season 1 • Beta',
    expansionId: Expansion.TheWarWithin,
    assetExpansionId: Expansion.TheWarWithin,
    patchId: ExpansionPatch.Patch_1100,
    assetPatchId: ExpansionPatch.Patch_1100,
    skipAffixAlerts: true,
    skipSuspiciousChecks: true,
    icon: 'inv_ability_voidweaverpriest_entropicrift',
    affixThreshold: [2, 4, 7],
    blizzardSeasonId: 13,
    isMainSeason: false,
    allowedDungeonPatches: [],
    allowedDungeons: [
      15093, // Ara-Kara, City of Echoes
      14979, // City of Threads
      14883, // The Stonevault
      14971, //The Dawnbreaker
      13334, // Mists of Tirna Scithe
      12916, // The Necrotic Wake
      9354, // Siege of Boralus
      4950 // Grim Batol
    ],
    supportsAffixes: false,
    supportsSpecs: true,
    supportsFactions: false,
    supportsMixedFactions: true,
    supportsTeams: true,
    supportsWeeklies: false,
    supportsCovenants: false,
    supportsRunRaceAndItemLevel: true,
    supportsScoreStats: false,
    supportsCutoffsPage: false,
    supportsRecruitment: false,
    supportsRouteGeneration: true,
    supportsReplays: true,
    loadoutFeatures: ['talents_df', 'tier', 'score'],
    allowedRealmTypes: [RealmConnectionType.BETA],
    partition: {
      type: SeasonPartitionType.BETA,
      eventId: getSeasonPartitionEventId(13, 1)
    },
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    starts: {
      us: moment.utc('2024-06-12T15:00:00'),
      eu: moment.utc('2024-06-13T04:00:00'),
      tw: moment.utc('2024-06-13T23:00:00'),
      kr: moment.utc('2024-06-13T23:00:00'),
      cn: moment.utc('2024-06-13T23:00:00')
    },
    ends: TWW_PRE_ACCESS_LAUNCH_DATES
  },
  {
    id: 45,
    slug: 'season-df-4-tr',
    name: 'Season 4 TR',
    short_name: 'DF4TR',
    scoringSystem: TScoringSystem.V7,
    title: 'DF Season 4 TR',
    expansionId: Expansion.Dragonflight,
    assetExpansionId: Expansion.Dragonflight,
    patchId: ExpansionPatch.Patch_1026,
    assetPatchId: ExpansionPatch.Patch_1026,
    skipAffixAlerts: false,
    icon: 'inv_10_enchanting2_elementalswirl_color1',
    affixThreshold: [2, 5, 10],
    blizzardSeasonId: 12,
    isMainSeason: false,
    allowedDungeonPatches: [],
    hidden: true,
    allowedDungeons: [
      14063, // Ruby Life Pools
      14032, // Algeth'ar Academy
      13982, // Nokhud Offensive
      13954, // Azure Vault
      14082, // Halls of Infusion
      13991, // Brackenhide Hollow
      13968, // Uldaman: Legacy of Tyr
      14011 // Neltharus
    ],
    supportsAffixes: true,
    supportsSpecs: true,
    supportsFactions: false,
    supportsMixedFactions: true,
    supportsTeams: true,
    supportsWeeklies: false,
    supportsCovenants: false,
    supportsRunRaceAndItemLevel: true,
    supportsScoreStats: true,
    supportsCutoffsPage: false,
    supportsRecruitment: false,
    supportsRouteGeneration: true,
    supportsReplays: true,
    loadoutFeatures: ['talents_df', 'tier', 'score'],
    partition: {
      type: SeasonPartitionType.TR,
      eventId: getSeasonPartitionEventId(12, 1)
    },
    allowedRealmTypes: [RealmConnectionType.TR],
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    starts: DF_SEASON4_DATES,
    ends: TWW_GLOBAL_LAUNCH_DATES
  },
  {
    id: 36,
    slug: 'season-df-3',
    name: 'Season 3',
    short_name: 'DF3',
    scoringSystem: TScoringSystem.V6,
    title: 'DF Season 3',
    expansionId: Expansion.Dragonflight,
    assetExpansionId: Expansion.Dragonflight,
    patchId: ExpansionPatch.Patch_1020,
    assetPatchId: ExpansionPatch.Patch_1020,
    skipAffixAlerts: false,
    icon: 'inv_achievement_raidemeralddream_raid',
    affixThreshold: [2, 7, 14],
    blizzardSeasonId: 11,
    isMainSeason: true,
    allowedDungeonPatches: [],
    allowedDungeons: [
      1000010, // Dawn of the Infinites: Galakrond's Fall
      1000011, // Dawn of the Infinites: Murozond's Rise
      7673, // Darkheart Thicket (Legion)
      7805, // Black Rook Hold (Legion)
      9424, // Waycrest Manor (Battle for Azeroth)
      9028, // Atal'Dazar (Battle for Azeroth)
      7109, // Everbloom (Warlords of Draenor)
      4738 // Throne of the Tides (Cataclysm)
    ],
    supportsAffixes: true,
    supportsSpecs: true,
    supportsFactions: false,
    supportsMixedFactions: true,
    supportsTeams: true,
    supportsWeeklies: true,
    supportsCovenants: false,
    supportsRunRaceAndItemLevel: true,
    supportsScoreStats: true,
    supportsCutoffsPage: true,
    supportsRecruitment: true,
    supportsRouteGeneration: true,
    supportsReplays: true,
    loadoutFeatures: ['talents_df', 'tier', 'score'],
    partition: {
      type: SeasonPartitionType.LIVE,
      eventId: getSeasonPartitionEventId(11, 0)
    },
    allowedRealmTypes: [RealmConnectionType.LIVE],
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    starts: DF_SEASON3_DATES,
    ends: DF_SEASON4_DATES
  },
  {
    id: 46,
    sortWeight: 1,
    slug: 'season-df-4-ptr',
    name: 'Season 4 • PTR',
    short_name: 'DF4PTR',
    scoringSystem: TScoringSystem.V7,
    title: 'DF Season 4 • PTR',
    expansionId: Expansion.Dragonflight,
    assetExpansionId: Expansion.Dragonflight,
    patchId: ExpansionPatch.Patch_1026,
    assetPatchId: ExpansionPatch.Patch_1026,
    skipAffixAlerts: true,
    skipSuspiciousChecks: true,
    hidden: true,
    icon: 'inv_10_enchanting2_elementalswirl_color1',
    affixThreshold: [2, 5, 10],
    blizzardSeasonId: 12,
    isMainSeason: false,
    allowedDungeonPatches: [],
    allowedDungeons: [
      14063, // Ruby Life Pools
      14032, // Algeth'ar Academy
      13982, // Nokhud Offensive
      13954, // Azure Vault
      14082, // Halls of Infusion
      13991, // Brackenhide Hollow
      13968, // Uldaman: Legacy of Tyr
      14011 // Neltharus
    ],
    supportsAffixes: true,
    supportsSpecs: true,
    supportsFactions: false,
    supportsMixedFactions: true,
    supportsTeams: true,
    supportsWeeklies: false,
    supportsCovenants: false,
    supportsRunRaceAndItemLevel: true,
    supportsScoreStats: false,
    supportsCutoffsPage: false,
    supportsRecruitment: false,
    supportsRouteGeneration: true,
    supportsReplays: true,
    loadoutFeatures: ['talents_df', 'tier', 'score'],
    allowedRealmTypes: [RealmConnectionType.PTR],
    partition: {
      type: SeasonPartitionType.PTR,
      eventId: getSeasonPartitionEventId(12, 2)
    },
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    starts: {
      us: moment.utc('2024-04-12T15:00:00'),
      eu: moment.utc('2024-04-13T04:00:00'),
      tw: moment.utc('2024-04-13T23:00:00'),
      kr: moment.utc('2024-04-13T23:00:00'),
      cn: moment.utc('2024-04-13T23:00:00')
    },
    ends: DF_SEASON4_DATES
  },
  {
    id: 43,
    slug: 'season-df-3-meta-vs-meta',
    name: 'DF Season 3 • Meta vs Meta',
    short_name: 'MvM DF3',
    scoringSystem: TScoringSystem.V6,
    title: 'DF Season 3 • Meta Vs Meta',
    affixThreshold: [2, 7, 14],
    icon: 'inv_mdi_awc_bannerreward_icons_blue',
    expansionId: Expansion.Dragonflight,
    assetExpansionId: Expansion.Dragonflight,
    patchId: ExpansionPatch.Patch_1020,
    assetPatchId: ExpansionPatch.Patch_1020,
    skipAffixAlerts: true,
    blizzardSeasonId: 10,
    isMainSeason: false,
    allowedRealmTypes: [RealmConnectionType.LIVE],
    allowedDungeonPatches: [],
    allowedDungeons: [
      1000010, // Dawn of the Infinites: Galakrond's Fall
      1000011, // Dawn of the Infinites: Murozond's Rise
      7673, // Darkheart Thicket (Legion)
      7805, // Black Rook Hold (Legion)
      9424, // Waycrest Manor (Battle for Azeroth)
      9028, // Atal'Dazar (Battle for Azeroth)
      7109, // Everbloom (Warlords of Draenor)
      4738 // Throne of the Tides (Cataclysm)
    ],
    supportsAffixes: true,
    supportsSpecs: true,
    supportsFactions: false,
    supportsMixedFactions: true,
    supportsTeams: true,
    supportsWeeklies: false, // temp event does not need to store weekly leaderboard
    supportsCovenants: false,
    supportsRunRaceAndItemLevel: true,
    supportsScoreStats: false,
    supportsCutoffsPage: false,
    supportsRecruitment: false,
    supportsRouteGeneration: true,
    supportsReplays: true,
    loadoutFeatures: ['talents_df', 'tier', 'score'],
    partition: {
      type: SeasonPartitionType.LIVE,
      // 58 is the bracketId used to create the event id on production. This is a hack to connect a bracket to a season for certain events such as BTM.
      eventId: DYNAMIC_BRACKET_EVENT_START + 58
    },
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    starts: {
      us: moment.utc('2024-04-02T15:00:00'),
      eu: moment.utc('2024-04-03T04:00:00'),
      tw: moment.utc('2024-04-03T23:00:00'),
      kr: moment.utc('2024-04-03T23:00:00'),
      cn: moment.utc('2024-04-03T23:00:00') // BTM not allowed in CN
    },
    ends: {
      us: moment.utc('2024-04-16T15:00:00'),
      eu: moment.utc('2024-04-17T04:00:00'),
      tw: moment.utc('2024-04-17T23:00:00'),
      kr: moment.utc('2024-04-17T23:00:00'),
      cn: moment.utc('2024-04-17T23:00:00') // BTM not allowed in CN
    }
  },
  {
    id: 42,
    slug: 'season-df-3-break-the-meta',
    name: 'DF Season 3 • Break the Meta',
    short_name: 'BTM DF3',
    scoringSystem: TScoringSystem.V6,
    title: 'DF Season 3 • Break the Meta',
    affixThreshold: [2, 7, 14],
    icon: 'inv_mdi_awc_bannerreward_icons_blue',
    expansionId: Expansion.Dragonflight,
    assetExpansionId: Expansion.Dragonflight,
    patchId: ExpansionPatch.Patch_1020,
    assetPatchId: ExpansionPatch.Patch_1020,
    skipAffixAlerts: true,
    blizzardSeasonId: 10,
    isMainSeason: false,
    allowedRealmTypes: [RealmConnectionType.LIVE],
    allowedDungeonPatches: [],
    allowedDungeons: [
      1000010, // Dawn of the Infinites: Galakrond's Fall
      1000011, // Dawn of the Infinites: Murozond's Rise
      7673, // Darkheart Thicket (Legion)
      7805, // Black Rook Hold (Legion)
      9424, // Waycrest Manor (Battle for Azeroth)
      9028, // Atal'Dazar (Battle for Azeroth)
      7109, // Everbloom (Warlords of Draenor)
      4738 // Throne of the Tides (Cataclysm)
    ],
    supportsAffixes: true,
    supportsSpecs: true,
    supportsFactions: false,
    supportsMixedFactions: true,
    supportsTeams: true,
    supportsWeeklies: false, // temp event does not need to store weekly leaderboard
    supportsCovenants: false,
    supportsRunRaceAndItemLevel: true,
    supportsScoreStats: false,
    supportsCutoffsPage: false,
    supportsRecruitment: false,
    supportsRouteGeneration: true,
    supportsReplays: true,
    loadoutFeatures: ['talents_df', 'tier', 'score'],
    partition: {
      type: SeasonPartitionType.LIVE,
      // 57 is the bracketId used to create the event id on production. This is a hack to connect a bracket to a season for certain events such as BTM.
      eventId: DYNAMIC_BRACKET_EVENT_START + 57
    },
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    starts: {
      us: moment.utc('2024-04-02T15:00:00'),
      eu: moment.utc('2024-04-03T04:00:00'),
      tw: moment.utc('2024-04-03T23:00:00'),
      kr: moment.utc('2024-04-03T23:00:00'),
      cn: moment.utc('2024-04-03T23:00:00') // BTM not allowed in CN
    },
    ends: {
      us: moment.utc('2024-04-16T15:00:00'),
      eu: moment.utc('2024-04-17T04:00:00'),
      tw: moment.utc('2024-04-17T23:00:00'),
      kr: moment.utc('2024-04-17T23:00:00'),
      cn: moment.utc('2024-04-17T23:00:00') // BTM not allowed in CN
    }
  },
  {
    id: 41,
    slug: 'season-df-3-tr',
    name: 'Season 3 TR',
    short_name: 'DF3TR',
    scoringSystem: TScoringSystem.V6,
    title: 'DF Season 3 TR',
    expansionId: Expansion.Dragonflight,
    assetExpansionId: Expansion.Dragonflight,
    patchId: ExpansionPatch.Patch_1020,
    assetPatchId: ExpansionPatch.Patch_1020,
    skipAffixAlerts: false,
    icon: 'inv_achievement_raidemeralddream_raid',
    affixThreshold: [2, 7, 14],
    blizzardSeasonId: 11,
    isMainSeason: false,
    allowedDungeonPatches: [],
    hidden: true,
    allowedDungeons: [
      1000010, // Dawn of the Infinites: Galakrond's Fall
      1000011, // Dawn of the Infinites: Murozond's Rise
      7673, // Darkheart Thicket (Legion)
      7805, // Black Rook Hold (Legion)
      9424, // Waycrest Manor (Battle for Azeroth)
      9028, // Atal'Dazar (Battle for Azeroth)
      7109, // Everbloom (Warlords of Draenor)
      4738 // Throne of the Tides (Cataclysm)
    ],
    supportsAffixes: true,
    supportsSpecs: true,
    supportsFactions: false,
    supportsMixedFactions: true,
    supportsTeams: true,
    supportsWeeklies: false,
    supportsCovenants: false,
    supportsRunRaceAndItemLevel: true,
    supportsScoreStats: true,
    supportsCutoffsPage: false,
    supportsRecruitment: false,
    supportsRouteGeneration: true,
    supportsReplays: true,
    loadoutFeatures: ['talents_df', 'tier', 'score'],
    partition: {
      type: SeasonPartitionType.TR,
      eventId: getSeasonPartitionEventId(11, 2)
    },
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    allowedRealmTypes: [RealmConnectionType.TR],
    starts: DF_SEASON3_DATES,
    ends: DF_SEASON4_DATES
  },
  {
    id: 29,
    slug: 'season-df-2',
    name: 'Season 2',
    short_name: 'DF2',
    scoringSystem: TScoringSystem.V6,
    title: 'DF Season 2',
    expansionId: Expansion.Dragonflight,
    assetExpansionId: Expansion.Dragonflight,
    patchId: ExpansionPatch.Patch_1010,
    assetPatchId: ExpansionPatch.Patch_1010,
    skipAffixAlerts: false,
    icon: 'achievement_zone_zaralekcavern',
    affixThreshold: [2, 7, 14],
    blizzardSeasonId: 10,
    isMainSeason: true,
    allowedDungeonPatches: [],
    allowedDungeons: [
      14082, // Halls of Infusion
      13991, // Brackenhide Hollow
      13968, // Uldaman: Legacy of Tyr
      14011, // Neltharus
      7546, // Neltharion's Lair
      9164, // Freehold
      9391, // Underrot
      5035 // Vortex Pinnacle
    ],
    supportsAffixes: true,
    supportsSpecs: true,
    supportsFactions: false,
    supportsMixedFactions: true,
    supportsTeams: true,
    supportsWeeklies: true,
    supportsCovenants: false,
    supportsRunRaceAndItemLevel: true,
    supportsScoreStats: true,
    supportsCutoffsPage: false,
    supportsRecruitment: true,
    supportsRouteGeneration: true,
    supportsReplays: true,
    loadoutFeatures: ['talents_df', 'tier', 'score'],
    allowedRealmTypes: [RealmConnectionType.LIVE, RealmConnectionType.TR],
    partition: {
      type: SeasonPartitionType.LIVE,
      eventId: getSeasonPartitionEventId(10, 0)
    },
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    starts: DF_SEASON2_DATES,
    ends: DF_SEASON3_DATES
  },
  {
    id: 39,
    slug: 'season-df-2-post',
    name: 'DF Season 2 • Post',
    short_name: 'DF2 (Post)',
    scoringSystem: TScoringSystem.V6,
    title: 'DF Season 2 • Post',
    affixThreshold: [2, 7, 14],
    icon: 'achievement_zone_zaralekcavern',
    expansionId: Expansion.Dragonflight,
    assetExpansionId: Expansion.Dragonflight,
    patchId: ExpansionPatch.Patch_1010,
    assetPatchId: ExpansionPatch.Patch_1010,
    skipAffixAlerts: true,
    blizzardSeasonId: 10,
    isMainSeason: false,
    allowedDungeonPatches: [],
    allowedDungeons: [
      14082, // Halls of Infusion
      13991, // Brackenhide Hollow
      13968, // Uldaman: Legacy of Tyr
      14011, // Neltharus
      7546, // Neltharion's Lair
      9164, // Freehold
      9391, // Underrot
      5035 // Vortex Pinnacle
    ],
    supportsAffixes: true,
    supportsSpecs: true,
    supportsFactions: false,
    supportsMixedFactions: true,
    supportsTeams: true,
    supportsWeeklies: false,
    supportsCovenants: false,
    supportsRunRaceAndItemLevel: true,
    supportsScoreStats: true,
    supportsCutoffsPage: false,
    supportsRecruitment: false,
    supportsRouteGeneration: true,
    allowedRealmTypes: [RealmConnectionType.LIVE, RealmConnectionType.TR],
    loadoutFeatures: ['talents_df', 'tier', 'score'],
    partition: {
      type: SeasonPartitionType.LIVE,
      eventId: getSeasonPartitionEventId(10, 4)
    },
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    starts: {
      us: moment.utc('2023-11-07T15:00:00'),
      eu: moment.utc('2023-11-08T04:00:00'),
      tw: moment.utc('2023-11-08T23:00:00'),
      kr: moment.utc('2023-11-08T23:00:00'),
      cn: moment.utc('2023-11-08T23:00:00')
    },
    ends: DF_SEASON3_DATES
  },
  {
    id: 40,
    slug: 'season-df-2-cutoffs',
    name: 'DF Season 2 • Cutoffs',
    short_name: 'DF2 (Cutoffs)',
    scoringSystem: TScoringSystem.V6,
    title: 'DF Season 2 • Cutoffs',
    affixThreshold: [2, 7, 14],
    icon: 'achievement_zone_zaralekcavern',
    hidden: true,
    expansionId: Expansion.Dragonflight,
    assetExpansionId: Expansion.Dragonflight,
    patchId: ExpansionPatch.Patch_1010,
    assetPatchId: ExpansionPatch.Patch_1010,
    skipAffixAlerts: true,
    skipLeaderboards: true,
    blizzardSeasonId: 10,
    isMainSeason: false,
    allowedDungeonPatches: [],
    allowedDungeons: [
      14082, // Halls of Infusion
      13991, // Brackenhide Hollow
      13968, // Uldaman: Legacy of Tyr
      14011, // Neltharus
      7546, // Neltharion's Lair
      9164, // Freehold
      9391, // Underrot
      5035 // Vortex Pinnacle
    ],
    supportsAffixes: true,
    supportsSpecs: true,
    supportsFactions: false,
    supportsMixedFactions: true,
    supportsTeams: true,
    supportsWeeklies: false,
    supportsCovenants: false,
    supportsRunRaceAndItemLevel: true,
    supportsScoreStats: true,
    supportsCutoffsPage: true,
    supportsRecruitment: false,
    supportsRouteGeneration: true,
    allowedRealmTypes: [RealmConnectionType.LIVE, RealmConnectionType.TR],
    loadoutFeatures: ['talents_df', 'tier', 'score'],
    partition: {
      type: SeasonPartitionType.LIVE,
      eventId: getSeasonPartitionEventId(10, 5)
    },
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    starts: DF_SEASON2_DATES,
    ends: {
      us: moment.utc('2023-11-07T15:00:00'),
      eu: moment.utc('2023-11-08T04:00:00'),
      tw: moment.utc('2023-11-08T23:00:00'),
      kr: moment.utc('2023-11-08T23:00:00'),
      cn: moment.utc('2023-11-08T23:00:00')
    }
  },
  {
    id: 37,
    slug: 'season-df-3-ptr',
    name: 'Season 3 • PTR',
    short_name: 'DF3PTR',
    scoringSystem: TScoringSystem.V6,
    title: 'DF Season 3 • PTR',
    expansionId: Expansion.Dragonflight,
    assetExpansionId: Expansion.Dragonflight,
    patchId: ExpansionPatch.Patch_1020,
    assetPatchId: ExpansionPatch.Patch_1020,
    skipAffixAlerts: true,
    skipSuspiciousChecks: true,
    hidden: true,
    icon: 'inv_achievement_raidemeralddream_raid',
    affixThreshold: [2, 7, 14],
    blizzardSeasonId: 11,
    isMainSeason: false,
    allowedDungeonPatches: [],
    allowedDungeons: [
      1000010, // Dawn of the Infinites: Galakrond's Fall
      1000011, // Dawn of the Infinites: Murozond's Rise
      7673, // Darkheart Thicket (Legion)
      7805, // Black Rook Hold (Legion)
      9424, // Waycrest Manor (Battle for Azeroth)
      9028, // Atal'Dazar (Battle for Azeroth)
      7109, // Everbloom (Warlords of Draenor)
      4738 // Throne of the Tides (Cataclysm)
    ],
    supportsAffixes: true,
    supportsSpecs: true,
    supportsFactions: false,
    supportsMixedFactions: true,
    supportsTeams: true,
    supportsWeeklies: false,
    supportsCovenants: false,
    supportsRunRaceAndItemLevel: true,
    supportsScoreStats: false,
    supportsCutoffsPage: false,
    supportsRecruitment: false,
    supportsRouteGeneration: true,
    supportsReplays: true,
    loadoutFeatures: ['talents_df', 'tier', 'score'],
    allowedRealmTypes: [RealmConnectionType.PTR],
    partition: {
      type: SeasonPartitionType.PTR,
      eventId: getSeasonPartitionEventId(11, 1)
    },
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    starts: {
      us: moment.utc('2023-09-12T15:00:00'),
      eu: moment.utc('2023-09-13T04:00:00'),
      tw: moment.utc('2023-09-13T23:00:00'),
      kr: moment.utc('2023-09-13T23:00:00'),
      cn: moment.utc('2023-09-13T23:00:00')
    },
    ends: DF_SEASON3_DATES
  },
  {
    id: 38,
    slug: 'season-df-2-break-the-meta',
    name: 'DF Season 2 • Break the Meta',
    short_name: 'BTM DF2',
    scoringSystem: TScoringSystem.V6,
    title: 'DF Season 2 • Break the Meta',
    affixThreshold: [2, 7, 14],
    icon: 'inv_misc_mdi_banner04',
    expansionId: Expansion.Dragonflight,
    assetExpansionId: Expansion.Dragonflight,
    patchId: ExpansionPatch.Patch_1017,
    assetPatchId: ExpansionPatch.Patch_1017,
    skipAffixAlerts: true,
    blizzardSeasonId: 10,
    isMainSeason: false,
    allowedRealmTypes: [RealmConnectionType.LIVE],
    allowedDungeonPatches: [],
    allowedDungeons: [
      14082, // Halls of Infusion
      13991, // Brackenhide Hollow
      13968, // Uldaman: Legacy of Tyr
      14011, // Neltharus
      7546, // Neltharion's Lair
      9164, // Freehold
      9391, // Underrot
      5035 // Vortex Pinnacle
    ],
    supportsAffixes: true,
    supportsSpecs: true,
    supportsFactions: false,
    supportsMixedFactions: true,
    supportsTeams: true,
    supportsWeeklies: false, // temp event does not need to store weekly leaderboard
    supportsCovenants: false,
    supportsRunRaceAndItemLevel: true,
    supportsScoreStats: true,
    supportsCutoffsPage: false,
    supportsRecruitment: false,
    supportsRouteGeneration: true,
    supportsReplays: true,
    loadoutFeatures: ['talents_df', 'tier', 'score'],
    partition: {
      type: SeasonPartitionType.LIVE,
      eventId: 10090
    },
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    starts: {
      us: moment.utc('2023-10-03T15:00:00'),
      eu: moment.utc('2023-10-04T04:00:00'),
      tw: moment.utc('2023-10-04T23:00:00'),
      kr: moment.utc('2023-10-04T23:00:00'),
      cn: moment.utc('2022-10-04T23:00:00') // BTM not allowed in CN
    },
    ends: {
      us: moment.utc('2023-10-10T15:00:00'),
      eu: moment.utc('2023-10-11T04:00:00'),
      tw: moment.utc('2023-10-11T23:00:00'),
      kr: moment.utc('2023-10-11T23:00:00'),
      cn: moment.utc('2022-10-11T23:00:00') // BTM not allowed in CN
    }
  },
  {
    id: 34,
    slug: 'season-df-2-tgp',
    name: 'Season 2 • TGP',
    short_name: 'DF2TGP',
    scoringSystem: TScoringSystem.V6,
    title: 'DF Season 2 TGP',
    expansionId: Expansion.Dragonflight,
    assetExpansionId: Expansion.Dragonflight,
    patchId: ExpansionPatch.Patch_1015,
    assetPatchId: ExpansionPatch.Patch_1015,
    icon: 'achievement_zone_zaralekcavern',
    affixThreshold: [2, 7, 14],
    blizzardSeasonId: 10,
    isMainSeason: false,
    allowedDungeonPatches: [],
    allowedDungeons: [
      14082, // Halls of Infusion
      13991, // Brackenhide Hollow
      13968, // Uldaman: Legacy of Tyr
      14011, // Neltharus
      7546, // Neltharion's Lair
      9164, // Freehold
      9391, // Underrot
      5035, // Vortex Pinnacle
      13954, // Azure Vault
      14032, // Algethar Academy
      14063 // Ruby Life Pools
    ],
    supportsAffixes: true,
    skipAffixAlerts: true,
    supportsSpecs: true,
    supportsFactions: false,
    supportsMixedFactions: true,
    supportsTeams: true,
    supportsWeeklies: false,
    supportsCovenants: false,
    supportsRunRaceAndItemLevel: true,
    supportsScoreStats: false,
    supportsCutoffsPage: false,
    supportsRecruitment: false,
    supportsRouteGeneration: true,
    supportsReplays: true,
    loadoutFeatures: ['talents_df', 'tier', 'score'],
    hidden: true,
    allowedRealmTypes: [RealmConnectionType.TR],
    partition: {
      type: SeasonPartitionType.LIVE,
      eventId: getSeasonPartitionEventId(10, 2)
    },
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    starts: {
      us: mdiDF2Timestamps.greatPushGroupA[0],
      eu: mdiDF2Timestamps.greatPushGroupA[0],
      tw: mdiDF2Timestamps.greatPushGroupA[0],
      kr: mdiDF2Timestamps.greatPushGroupA[0],
      cn: mdiDF2Timestamps.greatPushGroupA[0]
    },
    ends: {
      us: moment(mdiDF2Timestamps.greatPushFinals[0]).add(3, 'days'),
      eu: moment(mdiDF2Timestamps.greatPushFinals[0]).add(3, 'days'),
      tw: moment(mdiDF2Timestamps.greatPushFinals[0]).add(3, 'days'),
      kr: moment(mdiDF2Timestamps.greatPushFinals[0]).add(3, 'days'),
      cn: moment(mdiDF2Timestamps.greatPushFinals[0]).add(3, 'days')
    }
  },
  {
    id: 35,
    slug: 'season-df-2-post-1017',
    name: 'Season 2 • 10.1.7 Patch',
    short_name: 'DF2 10.1.7',
    scoringSystem: TScoringSystem.V6,
    title: 'DF Season 2 • 10.1.7 Patch',
    expansionId: Expansion.Dragonflight,
    assetExpansionId: Expansion.Dragonflight,
    patchId: ExpansionPatch.Patch_1017,
    assetPatchId: ExpansionPatch.Patch_1010,
    skipAffixAlerts: true,
    icon: 'achievement_bg_grab_cap_flagunderxseconds',
    affixThreshold: [2, 7, 14],
    blizzardSeasonId: 10,
    isMainSeason: false,
    allowedDungeonPatches: [],
    allowedRealmTypes: [RealmConnectionType.LIVE, RealmConnectionType.TR],
    allowedDungeons: [
      14082, // Halls of Infusion
      13991, // Brackenhide Hollow
      13968, // Uldaman: Legacy of Tyr
      14011, // Neltharus
      7546, // Neltharion's Lair
      9164, // Freehold
      9391, // Underrot
      5035 // Vortex Pinnacle
    ],
    supportsAffixes: true,
    supportsSpecs: true,
    supportsFactions: false,
    supportsMixedFactions: true,
    supportsTeams: true,
    supportsWeeklies: true,
    supportsCovenants: false,
    supportsRunRaceAndItemLevel: true,
    supportsScoreStats: true,
    supportsCutoffsPage: false,
    supportsRecruitment: true,
    supportsRouteGeneration: true,
    supportsReplays: true,
    loadoutFeatures: ['talents_df', 'tier', 'score'],
    partition: {
      type: SeasonPartitionType.LIVE,
      eventId: getSeasonPartitionEventId(10, 3)
    },
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    starts: {
      us: moment.utc('2023-09-05T15:00:00'),
      eu: moment.utc('2023-09-06T04:00:00'),
      tw: moment.utc('2023-09-06T23:00:00'),
      kr: moment.utc('2023-09-06T23:00:00'),
      cn: moment.utc('2023-09-06T23:00:00')
    },
    ends: DF_SEASON3_DATES
  },
  {
    id: 33,
    slug: 'season-df-2-post-1015',
    name: 'Season 2 • 10.1.5 Patch',
    short_name: 'DF2 10.1.5',
    scoringSystem: TScoringSystem.V6,
    title: 'DF Season 2 • 10.1.5 Patch',
    expansionId: Expansion.Dragonflight,
    assetExpansionId: Expansion.Dragonflight,
    patchId: ExpansionPatch.Patch_1015,
    assetPatchId: ExpansionPatch.Patch_1010,
    skipAffixAlerts: true,
    icon: 'achievement_bg_grab_cap_flagunderxseconds',
    affixThreshold: [2, 7, 14],
    blizzardSeasonId: 10,
    isMainSeason: false,
    allowedDungeonPatches: [],
    allowedRealmTypes: [RealmConnectionType.LIVE, RealmConnectionType.TR],
    allowedDungeons: [
      14082, // Halls of Infusion
      13991, // Brackenhide Hollow
      13968, // Uldaman: Legacy of Tyr
      14011, // Neltharus
      7546, // Neltharion's Lair
      9164, // Freehold
      9391, // Underrot
      5035 // Vortex Pinnacle
    ],
    supportsAffixes: true,
    supportsSpecs: true,
    supportsFactions: false,
    supportsMixedFactions: true,
    supportsTeams: true,
    supportsWeeklies: true,
    supportsCovenants: false,
    supportsRunRaceAndItemLevel: true,
    supportsScoreStats: true,
    supportsCutoffsPage: false,
    supportsRecruitment: true,
    supportsRouteGeneration: true,
    supportsReplays: true,
    loadoutFeatures: ['talents_df', 'tier', 'score'],
    partition: {
      type: SeasonPartitionType.LIVE,
      eventId: getSeasonPartitionEventId(10, 1)
    },
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    starts: {
      us: moment.utc('2023-07-11T15:00:00'),
      eu: moment.utc('2023-07-12T04:00:00'),
      tw: moment.utc('2023-07-12T23:00:00'),
      kr: moment.utc('2023-07-12T23:00:00'),
      cn: moment.utc('2023-07-12T23:00:00')
    },
    ends: DF_SEASON3_DATES
  },
  {
    id: 0,
    slug: 'season-df-1',
    name: 'Season 1',
    short_name: 'DF1',
    scoringSystem: TScoringSystem.V5,
    title: 'DF Season 1',
    affix: 'Thundering',
    affixId: 132,
    icon: 'spell_shaman_thunderstorm',
    expansionId: Expansion.Dragonflight,
    assetExpansionId: Expansion.Dragonflight,
    patchId: ExpansionPatch.Patch_1002,
    assetPatchId: ExpansionPatch.Patch_1002,
    affixThreshold: [2, 4, 7, 10],
    skipAffixAlerts: false,
    blizzardSeasonId: 9,
    isMainSeason: true,
    allowedDungeonPatches: [],
    allowedDungeons: [
      14063, // Ruby Life Pools
      14032, // Algeth'ar Academy
      13982, // Nokhud Offensive
      13954, // Azure Vault
      8079, // Court of Stars
      7672, // Halls of Valor
      6932, // Shadowmoon Burial Grounds
      5965 // Temple of the Jade Serpent
    ],
    supportsAffixes: true,
    supportsSpecs: true,
    supportsFactions: false,
    supportsMixedFactions: true,
    supportsTeams: true,
    supportsWeeklies: true,
    supportsCovenants: false,
    supportsRunRaceAndItemLevel: true,
    supportsScoreStats: true,
    supportsCutoffsPage: false,
    supportsRecruitment: true,
    loadoutFeatures: ['talents_df', 'tier', 'score'],
    partition: {
      type: SeasonPartitionType.LIVE,
      eventId: getSeasonPartitionEventId(9, 0)
    },
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    starts: {
      us: DF_LAUNCH_DATE,
      eu: DF_LAUNCH_DATE,
      tw: DF_LAUNCH_DATE,
      kr: DF_LAUNCH_DATE,
      cn: DF_LAUNCH_DATE
    },
    ends: DF_SEASON2_DATES
  },
  {
    id: 32,
    slug: 'season-df-1-post',
    name: 'DF Season 1 • Post',
    short_name: 'DF1 (Post)',
    scoringSystem: TScoringSystem.V5,
    title: 'DF Season 1 • Post',
    affix: 'Thundering',
    affixId: 132,
    affixThreshold: [2, 4, 7, 10],
    icon: 'spell_shaman_thunderstorm',
    expansionId: Expansion.Dragonflight,
    assetExpansionId: Expansion.Dragonflight,
    patchId: ExpansionPatch.Patch_1010,
    assetPatchId: ExpansionPatch.Patch_1002,
    skipAffixAlerts: true,
    blizzardSeasonId: 9,
    isMainSeason: false,
    allowedDungeonPatches: [],
    allowedDungeons: [
      14063, // Ruby Life Pools
      14032, // Algeth'ar Academy
      13982, // Nokhud Offensive
      13954, // Azure Vault
      8079, // Court of Stars
      7672, // Halls of Valor
      6932, // Shadowmoon Burial Grounds
      5965 // Temple of the Jade Serpent
    ],
    supportsSpecs: true,
    supportsAffixes: true,
    supportsFactions: false,
    supportsMixedFactions: true,
    supportsTeams: true,
    supportsWeeklies: false,
    supportsCovenants: false,
    supportsRunRaceAndItemLevel: true,
    supportsScoreStats: true,
    supportsCutoffsPage: false,
    supportsRecruitment: false,
    loadoutFeatures: ['talents_df', 'tier', 'score'],
    partition: {
      type: SeasonPartitionType.LIVE,
      eventId: getSeasonPartitionEventId(9, 2)
    },
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    starts: {
      us: moment.utc('2023-05-02T15:00:00'),
      eu: moment.utc('2023-05-03T04:00:00'),
      tw: moment.utc('2023-05-03T23:00:00'),
      kr: moment.utc('2023-05-03T23:00:00'),
      cn: moment.utc('2023-05-03T23:00:00')
    },
    ends: DF_SEASON2_DATES
  },
  {
    id: 31,
    slug: 'season-df-1-cutoffs',
    name: 'DF Season 1 • Cutoffs',
    short_name: 'DF1 (Cutoffs)',
    scoringSystem: TScoringSystem.V5,
    title: 'DF Season 1 • Cutoffs',
    affix: 'Thundering',
    affixId: 132,
    affixThreshold: [2, 4, 7, 10],
    icon: 'spell_shaman_thunderstorm',
    hidden: true,
    expansionId: Expansion.Dragonflight,
    assetExpansionId: Expansion.Dragonflight,
    patchId: ExpansionPatch.Patch_1002,
    assetPatchId: ExpansionPatch.Patch_1002,
    skipAffixAlerts: true,
    skipLeaderboards: true,
    blizzardSeasonId: 9,
    isMainSeason: false,
    allowedDungeonPatches: [],
    allowedDungeons: [
      14063, // Ruby Life Pools
      14032, // Algeth'ar Academy
      13982, // Nokhud Offensive
      13954, // Azure Vault
      8079, // Court of Stars
      7672, // Halls of Valor
      6932, // Shadowmoon Burial Grounds
      5965 // Temple of the Jade Serpent
    ],
    supportsSpecs: true,
    supportsAffixes: true,
    supportsFactions: false,
    supportsMixedFactions: true,
    supportsTeams: true,
    supportsWeeklies: false,
    supportsCovenants: false,
    supportsRunRaceAndItemLevel: true,
    supportsScoreStats: true,
    supportsCutoffsPage: true,
    supportsRecruitment: false,
    loadoutFeatures: ['talents_df', 'tier', 'score'],
    partition: {
      type: SeasonPartitionType.LIVE,
      eventId: getSeasonPartitionEventId(9, 1)
    },
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    starts: {
      us: DF_LAUNCH_DATE,
      eu: DF_LAUNCH_DATE,
      tw: DF_LAUNCH_DATE,
      kr: DF_LAUNCH_DATE,
      cn: DF_LAUNCH_DATE
    },
    ends: {
      us: moment.utc('2023-05-02T05:00:00'),
      eu: moment.utc('2023-05-02T20:00:00'),
      tw: moment.utc('2023-05-03T14:00:00'),
      kr: moment.utc('2023-05-03T14:00:00'),
      cn: moment.utc('2023-05-03T14:00:00')
    }
  },
  {
    id: 30,
    slug: 'season-df-1-break-the-meta',
    name: 'DF Season 1 • Break the Meta',
    short_name: 'BTM DF1',
    scoringSystem: TScoringSystem.V5,
    title: 'DF Season 1 • Break the Meta',
    affix: 'Thundering',
    affixId: 132,
    affixThreshold: [2, 4, 7, 10],
    icon: 'inv_misc_mdi_banner04',
    expansionId: Expansion.Dragonflight,
    assetExpansionId: Expansion.Dragonflight,
    patchId: ExpansionPatch.Patch_1002,
    assetPatchId: ExpansionPatch.Patch_1002,
    skipAffixAlerts: true,
    blizzardSeasonId: 9,
    isMainSeason: false,
    allowedDungeonPatches: [],
    allowedDungeons: [
      14063, // Ruby Life Pools
      14032, // Algeth'ar Academy
      13982, // Nokhud Offensive
      13954, // Azure Vault
      8079, // Court of Stars
      7672, // Halls of Valor
      6932, // Shadowmoon Burial Grounds
      5965 // Temple of the Jade Serpent
    ],
    supportsSpecs: true,
    supportsAffixes: true,
    supportsFactions: false,
    supportsMixedFactions: true,
    supportsTeams: true,
    supportsWeeklies: false, // temp event does not need to store weekly leaderboard
    supportsCovenants: false,
    supportsRunRaceAndItemLevel: true,
    supportsScoreStats: true,
    supportsCutoffsPage: false,
    supportsRecruitment: false,
    loadoutFeatures: ['talents_df', 'tier', 'score'],
    partition: {
      type: SeasonPartitionType.LIVE,
      eventId: 10078
    },
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    starts: {
      us: moment.utc('2023-04-18T15:00:00'),
      eu: moment.utc('2023-04-19T04:00:00'),
      tw: moment.utc('2023-04-19T23:00:00'),
      kr: moment.utc('2023-04-19T23:00:00'),
      cn: moment.utc('2022-10-05T23:00:00') // BTM not allowed in CN
    },
    ends: {
      us: moment.utc('2023-05-02T05:00:00'),
      eu: moment.utc('2023-05-02T20:00:00'),
      tw: moment.utc('2023-05-03T14:00:00'),
      kr: moment.utc('2023-05-03T14:00:00'),
      cn: moment.utc('2022-10-05T23:00:00') // BTM not allowed in CN
    }
  },
  {
    id: 1,
    slug: 'season-sl-4',
    name: 'Season 4',
    short_name: 'SL4',
    scoringSystem: TScoringSystem.V4,
    title: 'SL Season 4',
    affix: 'Shrouded',
    affixId: 131,
    affixThreshold: [2, 4, 7, 10],
    icon: 'spell_shadow_nethercloak',
    expansionId: Expansion.Shadowlands,
    assetExpansionId: Expansion.Shadowlands,
    patchId: ExpansionPatch.Patch_925,
    assetPatchId: ExpansionPatch.Patch_925,
    skipAffixAlerts: false,
    blizzardSeasonId: 8,
    isMainSeason: true,
    allowedDungeonPatches: ['6.0', '7.2', '8.3', '9.2.0'],
    allowedDungeons: [6951, 6984, 800001, 800002, 999998, 999999, 1000000, 1000001],
    supportsAffixes: true,
    supportsSpecs: true,
    supportsFactions: false,
    supportsMixedFactions: true,
    supportsTeams: true,
    supportsWeeklies: true,
    supportsCovenants: true,
    supportsRunRaceAndItemLevel: true,
    supportsScoreStats: true,
    supportsCutoffsPage: true,
    supportsRecruitment: true,
    loadoutFeatures: ['talents', 'legendaries', 'covenant', 'tier', 'score'],
    partition: {
      type: SeasonPartitionType.LIVE,
      eventId: getSeasonPartitionEventId(8, 0)
    },
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    starts: {
      us: moment.utc('2022-08-02T15:00:00'),
      eu: moment.utc('2022-08-03T07:00:00'),
      tw: moment.utc('2022-08-03T23:00:00'),
      kr: moment.utc('2022-08-03T23:00:00'),
      cn: moment.utc('2022-08-03T23:00:00')
    },
    ends: DF_PREPATCH_LAUNCH_DATES
  },
  {
    id: 2,
    slug: 'season-sl-4-post',
    name: 'Season 4 • Post',
    short_name: 'Post SL4',
    scoringSystem: TScoringSystem.V4,
    title: 'SL Season 4 • Post',
    affix: 'Shrouded',
    affixId: 131,
    affixThreshold: [2, 4, 7, 10],
    icon: 'spell_shadow_nethercloak',
    expansionId: Expansion.Shadowlands,
    assetExpansionId: Expansion.Shadowlands,
    patchId: ExpansionPatch.Patch_925,
    assetPatchId: ExpansionPatch.Patch_925,
    skipAffixAlerts: false,
    blizzardSeasonId: 8,
    isMainSeason: false,
    allowedDungeonPatches: ['6.0', '7.2', '8.3', '9.2.0'],
    allowedDungeons: [6951, 6984, 800001, 800002, 999998, 999999, 1000000, 1000001],
    supportsAffixes: true,
    supportsSpecs: true,
    supportsFactions: false,
    supportsMixedFactions: true,
    supportsTeams: true,
    supportsWeeklies: true,
    supportsCovenants: true,
    supportsRunRaceAndItemLevel: true,
    supportsScoreStats: true,
    supportsCutoffsPage: true,
    supportsRecruitment: true,
    loadoutFeatures: ['talents_df', 'covenant', 'score'],
    partition: {
      type: SeasonPartitionType.LIVE,
      eventId: getSeasonPartitionEventId(8, 2)
    },
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    starts: {
      us: moment.utc('2022-08-02T15:00:00'),
      eu: moment.utc('2022-08-03T07:00:00'),
      tw: moment.utc('2022-08-03T23:00:00'),
      kr: moment.utc('2022-08-03T23:00:00'),
      cn: moment.utc('2022-08-03T23:00:00')
    },
    ends: {
      us: DF_LAUNCH_DATE,
      eu: DF_LAUNCH_DATE,
      tw: DF_LAUNCH_DATE,
      kr: DF_LAUNCH_DATE,
      cn: DF_LAUNCH_DATE
    }
  },
  {
    id: 3,
    slug: 'season-sl-4-patch-10-0',
    name: 'Season 4 • 10.0 Patch',
    short_name: 'SL4 10.0',
    scoringSystem: TScoringSystem.V4,
    title: 'SL Season 4 • 10.0 Patch',
    affix: 'Shrouded',
    affixId: 131,
    affixThreshold: [2, 4, 7, 10],
    icon: 'spell_shadow_nethercloak',
    expansionId: Expansion.Shadowlands,
    assetExpansionId: Expansion.Shadowlands,
    patchId: ExpansionPatch.Patch_925,
    assetPatchId: ExpansionPatch.Patch_925,
    skipAffixAlerts: false,
    blizzardSeasonId: 8,
    isMainSeason: false,
    allowedDungeonPatches: ['6.0', '7.2', '8.3', '9.2.0'],
    allowedDungeons: [6951, 6984, 800001, 800002, 999998, 999999, 1000000, 1000001],
    supportsAffixes: true,
    supportsSpecs: true,
    supportsFactions: false,
    supportsMixedFactions: true,
    supportsTeams: true,
    supportsWeeklies: true,
    supportsCovenants: true,
    supportsRunRaceAndItemLevel: true,
    supportsScoreStats: true,
    supportsCutoffsPage: true,
    supportsRecruitment: true,
    loadoutFeatures: ['talents_df', 'covenant', 'score'],
    partition: {
      type: SeasonPartitionType.LIVE,
      eventId: getSeasonPartitionEventId(8, 3)
    },
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    starts: DF_PREPATCH_LAUNCH_DATES,
    ends: {
      us: DF_LAUNCH_DATE,
      eu: DF_LAUNCH_DATE,
      tw: DF_LAUNCH_DATE,
      kr: DF_LAUNCH_DATE,
      cn: DF_LAUNCH_DATE
    }
  },
  {
    id: 4,
    slug: 'season-sl-4-break-the-meta',
    name: 'Season 4 • Break the Meta',
    short_name: 'BTM SL4',
    scoringSystem: TScoringSystem.V4,
    title: 'SL Season 4 • Break the Meta',
    affix: 'Shrouded',
    affixId: 131,
    affixThreshold: [2, 4, 7, 10],
    icon: 'inv_misc_mdi_banner03',
    expansionId: Expansion.Shadowlands,
    assetExpansionId: Expansion.Shadowlands,
    patchId: ExpansionPatch.Patch_925,
    assetPatchId: ExpansionPatch.Patch_925,
    skipAffixAlerts: false,
    blizzardSeasonId: 8,
    isMainSeason: false,
    allowedDungeonPatches: ['6.0', '7.2', '8.3', '9.2.0'],
    allowedDungeons: [6951, 6984, 800001, 800002, 999998, 999999, 1000000, 1000001],
    supportsAffixes: true,
    supportsSpecs: true,
    supportsFactions: false,
    supportsMixedFactions: true,
    supportsTeams: true,
    supportsWeeklies: false, // temp event does not need to store weekly leaderboard
    supportsCovenants: true,
    supportsRunRaceAndItemLevel: true,
    supportsScoreStats: true,
    supportsCutoffsPage: false,
    supportsRecruitment: false,
    loadoutFeatures: ['talents', 'legendaries', 'covenant', 'tier', 'score'],
    partition: {
      type: SeasonPartitionType.LIVE,
      eventId: 50011
    },
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    starts: {
      us: moment.utc('2022-10-04T15:00:00'),
      eu: moment.utc('2022-10-05T07:00:00'),
      tw: moment.utc('2022-10-05T23:00:00'),
      kr: moment.utc('2022-10-05T23:00:00'),
      cn: moment.utc('2022-10-05T23:00:00') // BTM not allowed in CN
    },
    ends: {
      us: moment.utc('2022-10-11T15:00:00'),
      eu: moment.utc('2022-10-12T07:00:00'),
      tw: moment.utc('2022-10-12T23:00:00'),
      kr: moment.utc('2022-10-12T23:00:00'),
      cn: moment.utc('2022-10-05T23:00:01') // BTM not allowed in CN
    }
  },
  {
    id: 5,
    slug: 'season-sl-4-legion-timewalking',
    name: 'Season 4 • Legion Timewalking',
    short_name: 'SL4 (TW)',
    scoringSystem: TScoringSystem.V4,
    title: 'SL Season 4 • Legion Timewalking',
    affix: 'Infernal',
    affixId: 129,
    affixThreshold: [2, 4, 7, 10],
    icon: 'inv_infernalbrimstone',
    expansionId: Expansion.Shadowlands,
    assetExpansionId: Expansion.Legion,
    patchId: ExpansionPatch.Patch_925,
    assetPatchId: ExpansionPatch.Patch_700,
    blizzardSeasonId: 8,
    isMainSeason: false,
    allowedDungeonPatches: ['7.0'],
    allowedDungeons: [7805, 8079, 7673, 8040, 7546, 7787],
    supportsAffixes: true,
    supportsSpecs: true,
    supportsFactions: false,
    supportsTeams: true,
    supportsWeeklies: true,
    supportsCovenants: true,
    supportsRunRaceAndItemLevel: true,
    supportsScoreStats: false,
    skipAffixAlerts: true,
    loadoutFeatures: ['talents', 'legendaries', 'covenant', 'tier', 'score'],
    partition: {
      type: SeasonPartitionType.LIVE,
      eventId: getSeasonPartitionEventId(8, 1)
    },
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    starts: {
      us: moment.utc('2022-08-16T15:00:00'),
      eu: moment.utc('2022-08-17T07:00:00'),
      tw: moment.utc('2022-08-17T23:00:00'),
      kr: moment.utc('2022-08-17T23:00:00'),
      cn: moment.utc('2022-08-17T23:00:00')
    },
    ends: DF_PREPATCH_LAUNCH_DATES
  },
  {
    id: 6,
    slug: 'season-sl-3',
    name: 'Season 3',
    short_name: 'SL3',
    scoringSystem: TScoringSystem.V4,
    title: 'SL Season 3',
    affix: 'Encrypted',
    affixId: 130,
    affixThreshold: [2, 4, 7, 10],
    icon: 'spell_progenitor_orb',
    expansionId: Expansion.Shadowlands,
    assetExpansionId: Expansion.Shadowlands,
    patchId: ExpansionPatch.Patch_920,
    assetPatchId: ExpansionPatch.Patch_920,
    blizzardSeasonId: 7,
    isMainSeason: true,
    allowedDungeonPatches: ['9.0.2', '9.2.0'],
    supportsAffixes: true,
    supportsSpecs: true,
    supportsFactions: false,
    supportsMixedFactions: true,
    supportsTeams: true,
    supportsWeeklies: true,
    supportsCovenants: true,
    supportsRunRaceAndItemLevel: true,
    supportsScoreStats: true,
    supportsCutoffsPage: true,
    supportsRecruitment: true,
    loadoutFeatures: ['talents', 'legendaries', 'covenant', 'tier', 'score'],
    partition: {
      type: SeasonPartitionType.LIVE,
      eventId: getSeasonPartitionEventId(7, 0)
    },
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    starts: {
      us: moment.utc('2022-03-01T15:00:00'),
      eu: moment.utc('2022-03-02T07:00:00'),
      tw: moment.utc('2022-03-02T23:00:00'),
      kr: moment.utc('2022-03-02T23:00:00'),
      cn: moment.utc('2022-03-02T23:00:00')
    },
    ends: {
      us: moment.utc('2022-08-02T15:00:00'),
      eu: moment.utc('2022-08-03T07:00:00'),
      tw: moment.utc('2022-08-03T23:00:00'),
      kr: moment.utc('2022-08-03T23:00:00'),
      cn: moment.utc('2022-08-03T23:00:00')
    }
  },
  {
    id: 7,
    slug: 'season-sl-3-post-925',
    name: 'Season 3 • Post 9.2.5',
    short_name: 'SL3 (925)',
    scoringSystem: TScoringSystem.V4,
    title: 'SL Season 3 • Post 9.2.5',
    affix: 'Encrypted',
    affixId: 130,
    affixThreshold: [2, 4, 7, 10],
    icon: 'spell_progenitor_orb',
    expansionId: Expansion.Shadowlands,
    assetExpansionId: Expansion.Shadowlands,
    patchId: ExpansionPatch.Patch_920,
    assetPatchId: ExpansionPatch.Patch_920,
    blizzardSeasonId: 7,
    isMainSeason: false,
    allowedDungeonPatches: ['9.0.2', '9.2.0'],
    supportsAffixes: true,
    supportsSpecs: true,
    supportsFactions: false,
    supportsMixedFactions: true,
    supportsTeams: true,
    supportsWeeklies: true,
    supportsCovenants: true,
    supportsRunRaceAndItemLevel: true,
    supportsScoreStats: true,
    supportsRecruitment: false,
    loadoutFeatures: ['talents', 'legendaries', 'covenant', 'score'],
    partition: {
      type: SeasonPartitionType.LIVE,
      eventId: getSeasonPartitionEventId(7, 2)
    },
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    starts: {
      us: moment.utc('2022-05-31T15:00:00'),
      eu: moment.utc('2022-06-01T07:00:00'),
      tw: moment.utc('2022-06-01T23:00:00'),
      kr: moment.utc('2022-06-01T23:00:00'),
      cn: moment.utc('2022-06-01T23:00:00')
    },
    ends: {
      us: moment.utc('2022-08-02T15:00:00'),
      eu: moment.utc('2022-08-03T07:00:00'),
      tw: moment.utc('2022-08-03T23:00:00'),
      kr: moment.utc('2022-08-03T23:00:00'),
      cn: moment.utc('2022-08-03T23:00:00')
    }
  },
  {
    id: 8,
    slug: 'season-sl-3-legion-timewalking',
    name: 'Season 3 • Legion Timewalking',
    short_name: 'SL3 (TW)',
    scoringSystem: TScoringSystem.V4,
    title: 'SL Season 3 • Legion Timewalking',
    affix: 'Infernal',
    affixId: 129,
    affixThreshold: [2, 4, 7, 10],
    icon: 'inv_infernalbrimstone',
    expansionId: Expansion.Shadowlands,
    assetExpansionId: Expansion.Legion,
    patchId: ExpansionPatch.Patch_920,
    assetPatchId: ExpansionPatch.Patch_700,
    blizzardSeasonId: 7,
    isMainSeason: false,
    allowedDungeonPatches: ['7.0'],
    allowedDungeons: [7805, 8079, 7673, 8040, 7546, 7787],
    supportsAffixes: true,
    supportsSpecs: true,
    supportsFactions: false,
    supportsTeams: true,
    supportsWeeklies: true,
    supportsCovenants: true,
    supportsRunRaceAndItemLevel: true,
    supportsScoreStats: false,
    skipAffixAlerts: true,
    loadoutFeatures: ['talents', 'legendaries', 'covenant', 'score'],
    partition: {
      type: SeasonPartitionType.LIVE,
      eventId: getSeasonPartitionEventId(7, 1)
    },
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    starts: {
      us: moment.utc('2022-04-12T15:00:00'),
      eu: moment.utc('2022-04-13T07:00:00'),
      tw: moment.utc('2022-04-13T23:00:00'),
      kr: moment.utc('2022-04-13T23:00:00'),
      cn: moment.utc('2022-04-13T23:00:00')
    },
    ends: {
      us: moment.utc('2022-08-02T15:00:00'),
      eu: moment.utc('2022-08-03T07:00:00'),
      tw: moment.utc('2022-08-03T23:00:00'),
      kr: moment.utc('2022-08-03T23:00:00'),
      cn: moment.utc('2022-08-03T23:00:00')
    }
  },
  {
    id: 9,
    slug: 'season-sl-2',
    name: 'Season 2 • Overall',
    short_name: 'SL2',
    scoringSystem: TScoringSystem.V4,
    title: 'SL Season 2 • Overall',
    affix: 'Tormented',
    affixId: 128,
    affixThreshold: [2, 4, 7, 10],
    icon: 'spell_animamaw_orb',
    expansionId: Expansion.Shadowlands,
    assetExpansionId: Expansion.Shadowlands,
    patchId: ExpansionPatch.Patch_910,
    assetPatchId: ExpansionPatch.Patch_910,
    blizzardSeasonId: 6,
    isMainSeason: true,
    allowedDungeonPatches: ['9.0.2'],
    supportsAffixes: true,
    supportsSpecs: true,
    supportsFactions: true,
    supportsTeams: true,
    supportsWeeklies: true,
    supportsCovenants: true,
    supportsRecruitment: true,
    loadoutFeatures: ['talents', 'legendaries', 'covenant', 'score'],
    partition: {
      type: SeasonPartitionType.LIVE,
      eventId: getSeasonPartitionEventId(6, 0)
    },
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    starts: {
      us: moment.utc('2021-07-06T15:00:00'),
      eu: moment.utc('2021-07-07T07:00:00'),
      tw: moment.utc('2021-07-07T23:00:00'),
      kr: moment.utc('2021-07-07T23:00:00'),
      cn: moment.utc('2021-07-07T23:00:00')
    },
    ends: {
      us: moment.utc('2022-03-01T15:00:00'),
      eu: moment.utc('2022-03-02T07:00:00'),
      tw: moment.utc('2022-03-02T23:00:00'),
      kr: moment.utc('2022-03-02T23:00:00'),
      cn: moment.utc('2022-03-02T23:00:00')
    }
  },
  {
    id: 10,
    slug: 'season-sl-2-post',
    name: 'SL Season 2 • Post 9.2.0',
    short_name: 'SL2-P',
    scoringSystem: TScoringSystem.V4,
    title: 'SL Season 2 • Post 9.2.0',
    affix: 'Tormented',
    affixId: 128,
    affixThreshold: [2, 4, 7, 10],
    icon: 'spell_animamaw_orb',
    expansionId: Expansion.Shadowlands,
    assetExpansionId: Expansion.Shadowlands,
    patchId: ExpansionPatch.Patch_910,
    assetPatchId: ExpansionPatch.Patch_910,
    blizzardSeasonId: 6,
    isMainSeason: false,
    allowedDungeonPatches: ['9.0.2'],
    supportsAffixes: true,
    supportsSpecs: true,
    supportsFactions: true,
    supportsTeams: true,
    supportsWeeklies: true,
    supportsCovenants: true,
    loadoutFeatures: ['talents', 'legendaries', 'covenant', 'score'],
    partition: {
      type: SeasonPartitionType.LIVE,
      eventId: getSeasonPartitionEventId(6, 3)
    },
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    starts: {
      us: moment.utc('2022-02-22T15:00:00'),
      eu: moment.utc('2022-02-23T07:00:00'),
      tw: moment.utc('2022-02-23T23:00:00'),
      kr: moment.utc('2022-02-23T23:00:00'),
      cn: moment.utc('2022-02-23T23:00:00')
    },
    ends: {
      us: moment.utc('2022-03-01T15:00:00'),
      eu: moment.utc('2022-03-02T07:00:00'),
      tw: moment.utc('2022-03-02T23:00:00'),
      kr: moment.utc('2022-03-02T23:00:00'),
      cn: moment.utc('2022-03-02T23:00:00')
    }
  },
  {
    id: 11,
    slug: 'season-sl-2-tormented-hero',
    name: 'SL Season 2 • Tormented Hero',
    short_name: 'SL2 Tormented Hero',
    scoringSystem: TScoringSystem.V4,
    title: 'SL Season 2 • Tormented Hero',
    affix: 'Tormented',
    affixId: 128,
    affixThreshold: [2, 4, 7, 10],
    icon: 'spell_animamaw_orb',
    hidden: true,
    expansionId: Expansion.Shadowlands,
    assetExpansionId: Expansion.Shadowlands,
    patchId: ExpansionPatch.Patch_910,
    assetPatchId: ExpansionPatch.Patch_910,
    blizzardSeasonId: 6,
    isMainSeason: false,
    allowedDungeonPatches: ['9.0.2'],
    skipAffixAlerts: true,
    skipLeaderboards: true,
    supportsAffixes: true,
    supportsSpecs: true,
    supportsFactions: true,
    supportsTeams: true,
    supportsWeeklies: true,
    supportsCovenants: true,
    loadoutFeatures: ['talents', 'legendaries', 'covenant', 'score'],
    partition: {
      type: SeasonPartitionType.LIVE,
      eventId: getSeasonPartitionEventId(6, 4)
    },
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    starts: {
      us: moment.utc('2021-07-06T15:00:00'),
      eu: moment.utc('2021-07-07T07:00:00'),
      tw: moment.utc('2021-07-07T23:00:00'),
      kr: moment.utc('2021-07-07T23:00:00'),
      cn: moment.utc('2021-07-07T23:00:00')
    },
    ends: {
      us: moment.utc('2022-02-22T15:00:00'),
      eu: moment.utc('2022-02-23T07:00:00'),
      tw: moment.utc('2022-02-23T23:00:00'),
      kr: moment.utc('2022-02-23T23:00:00'),
      cn: moment.utc('2022-02-23T23:00:00')
    }
  },
  {
    id: 12,
    slug: 'season-sl-2-post-915',
    name: 'Season 2 • Post 9.1.5',
    short_name: 'SL2 (915)',
    scoringSystem: TScoringSystem.V4,
    title: 'SL Season 2 • Post 9.1.5',
    affix: 'Tormented',
    affixId: 128,
    affixThreshold: [2, 4, 7, 10],
    icon: 'spell_animamaw_orb',
    expansionId: Expansion.Shadowlands,
    assetExpansionId: Expansion.Shadowlands,
    patchId: ExpansionPatch.Patch_910,
    assetPatchId: ExpansionPatch.Patch_910,
    blizzardSeasonId: 6,
    isMainSeason: false,
    allowedDungeonPatches: ['9.0.2'],
    supportsAffixes: true,
    supportsSpecs: true,
    supportsFactions: true,
    supportsTeams: true,
    supportsWeeklies: true,
    supportsCovenants: true,
    loadoutFeatures: ['talents', 'legendaries', 'covenant', 'score'],
    partition: {
      type: SeasonPartitionType.LIVE,
      eventId: getSeasonPartitionEventId(6, 1)
    },
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    starts: {
      us: moment.utc('2021-11-02T15:00:00'),
      eu: moment.utc('2021-11-03T07:00:00'),
      tw: moment.utc('2021-11-03T23:00:00'),
      kr: moment.utc('2021-11-03T23:00:00'),
      cn: moment.utc('2021-11-03T23:00:00')
    },
    ends: {
      us: moment.utc('2022-02-22T15:00:00'),
      eu: moment.utc('2022-02-23T07:00:00'),
      tw: moment.utc('2022-02-23T23:00:00'),
      kr: moment.utc('2022-02-23T23:00:00'),
      cn: moment.utc('2022-02-23T23:00:00')
    }
  },
  {
    id: 13,
    slug: 'season-sl-2-legion-timewalking',
    name: 'Season 2 • Legion Timewalking',
    short_name: 'SL2 (TW)',
    scoringSystem: TScoringSystem.V4,
    title: 'SL Season 2 • Legion Timewalking',
    affix: 'Infernal',
    affixId: 129,
    affixThreshold: [2, 4, 7, 10],
    icon: 'inv_infernalbrimstone',
    expansionId: Expansion.Shadowlands,
    assetExpansionId: Expansion.Legion,
    patchId: ExpansionPatch.Patch_910,
    assetPatchId: ExpansionPatch.Patch_700,
    blizzardSeasonId: 6,
    isMainSeason: false,
    allowedDungeonPatches: ['7.0'],
    allowedDungeons: [7805, 8079, 7673, 8040, 7546, 7787],
    supportsAffixes: true,
    supportsSpecs: true,
    supportsFactions: true,
    supportsTeams: true,
    supportsWeeklies: true,
    supportsCovenants: true,
    loadoutFeatures: ['talents', 'legendaries', 'covenant', 'score'],
    skipAffixAlerts: true,
    partition: {
      type: SeasonPartitionType.LIVE,
      eventId: getSeasonPartitionEventId(6, 2)
    },
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    starts: {
      us: moment.utc('2021-12-07T15:00:00'),
      eu: moment.utc('2021-12-08T07:00:00'),
      tw: moment.utc('2021-12-08T23:00:00'),
      kr: moment.utc('2021-12-08T23:00:00'),
      cn: moment.utc('2021-12-08T23:00:00')
    },
    ends: {
      us: moment.utc('2022-02-22T15:00:00'),
      eu: moment.utc('2022-02-23T07:00:00'),
      tw: moment.utc('2022-02-23T23:00:00'),
      kr: moment.utc('2022-02-23T23:00:00'),
      cn: moment.utc('2022-02-23T23:00:00')
    }
  },
  {
    id: 14,
    slug: 'season-sl-1',
    name: 'Season 1',
    short_name: 'SL1',
    scoringSystem: TScoringSystem.V3,
    title: 'SL Season 1',
    affix: 'Prideful',
    affixId: 121,
    affixThreshold: [2, 4, 7, 10],
    icon: 'spell_animarevendreth_buff',
    expansionId: Expansion.Shadowlands,
    assetExpansionId: Expansion.Shadowlands,
    patchId: ExpansionPatch.Patch_902,
    assetPatchId: ExpansionPatch.Patch_902,
    blizzardSeasonId: 5,
    isMainSeason: true,
    allowedDungeonPatches: ['9.0.2'],
    supportsAffixes: true,
    supportsSpecs: true,
    supportsFactions: true,
    supportsTeams: true,
    supportsWeeklies: true,
    supportsCovenants: true,
    loadoutFeatures: ['talents', 'legendaries', 'covenant', 'score'],
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    partition: {
      type: SeasonPartitionType.LIVE,
      eventId: SEASON_SL1_PARTITION_EVENT_ID
    },
    starts: {
      us: moment.utc('2020-12-08T15:00:00'),
      eu: moment.utc('2020-12-09T07:00:00'),
      tw: moment.utc('2020-12-09T23:00:00'),
      kr: moment.utc('2020-12-09T23:00:00'),
      cn: moment.utc('2020-12-09T23:00:00')
    },
    ends: {
      us: moment.utc('2021-06-29T15:00:00'),
      eu: moment.utc('2021-06-30T07:00:00'),
      tw: moment.utc('2021-06-30T23:00:00'),
      kr: moment.utc('2021-06-30T23:00:00'),
      cn: moment.utc('2021-06-30T23:00:00')
    }
  },

  // NOTE: Important that the post season is AFTER the regular season, because
  // the regular season is marked to end first, so this will allow the system
  // to smoothly move people to the post season when the regular season is over
  {
    id: 15,
    slug: 'season-sl-1-post',
    name: 'Post-Season 1',
    short_name: 'SL1-P',
    scoringSystem: TScoringSystem.V4,
    title: 'SL Post-Season 1',
    affix: 'Prideful',
    affixId: 121,
    affixThreshold: [2, 4, 7, 10],
    icon: 'spell_animarevendreth_buff',
    expansionId: Expansion.Shadowlands,
    assetExpansionId: Expansion.Shadowlands,
    patchId: ExpansionPatch.Patch_910,
    assetPatchId: ExpansionPatch.Patch_910,
    blizzardSeasonId: 5,
    isMainSeason: false,
    partition: {
      type: SeasonPartitionType.LIVE,
      eventId: getSeasonPartitionEventId(5, 1)
    },
    allowedDungeonPatches: ['9.0.2'],
    supportsAffixes: true,
    supportsSpecs: true,
    supportsFactions: true,
    supportsTeams: true,
    supportsWeeklies: true,
    supportsCovenants: true,
    loadoutFeatures: ['talents', 'legendaries', 'covenant', 'score'],
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    starts: {
      us: moment.utc('2020-12-08T15:00:00'),
      eu: moment.utc('2020-12-09T07:00:00'),
      tw: moment.utc('2020-12-09T23:00:00'),
      kr: moment.utc('2020-12-09T23:00:00'),
      cn: moment.utc('2020-12-09T23:00:00')
    },
    ends: {
      us: moment.utc('2021-07-06T15:00:00'),
      eu: moment.utc('2021-07-07T07:00:00'),
      tw: moment.utc('2021-07-07T23:00:00'),
      kr: moment.utc('2021-07-07T23:00:00'),
      cn: moment.utc('2021-07-07T23:00:00')
    }
  },
  {
    id: 16,
    slug: 'season-bfa-4-post',
    name: 'Post-Season 4',
    short_name: 'BFA4-P',
    scoringSystem: TScoringSystem.V3,
    title: 'BFA Post-Season 4',
    affix: 'Awakened',
    affixId: 120,
    affixThreshold: [2, 4, 7, 10],
    icon: 'trade_archaeology_nerubian_obelisk',
    expansionId: Expansion.BattleForAzeroth,
    assetExpansionId: Expansion.BattleForAzeroth,
    patchId: ExpansionPatch.Patch_901,
    assetPatchId: ExpansionPatch.Patch_901,
    blizzardSeasonId: 4,
    isMainSeason: false,
    allowedDungeonPatches: ['8.0', '8.1', '8.1.5', '8.2', '8.3'],
    supportsAffixes: true,
    supportsSpecs: true,
    supportsFactions: true,
    supportsTeams: true,
    supportsWeeklies: true,
    loadoutFeatures: ['azerite', 'essences', 'talents'],
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    starts: {
      us: moment.utc('2020-10-13T15:00:00'),
      eu: moment.utc('2020-10-14T07:00:00'),
      tw: moment.utc('2020-10-14T23:00:00'),
      kr: moment.utc('2020-10-14T23:00:00'),
      cn: moment.utc('2020-10-14T23:00:00')
    },
    ends: {
      us: moment.utc('2020-12-08T15:00:00'),
      eu: moment.utc('2020-12-09T07:00:00'),
      tw: moment.utc('2020-12-09T23:00:00'),
      kr: moment.utc('2020-12-09T23:00:00'),
      cn: moment.utc('2020-12-09T23:00:00')
    }
  },
  {
    id: 17,
    slug: 'season-bfa-4',
    name: 'Season 4',
    short_name: 'BFA4',
    scoringSystem: TScoringSystem.V3,
    title: 'BFA Season 4',
    affix: 'Awakened',
    affixId: 120,
    affixThreshold: [2, 4, 7, 10],
    icon: 'trade_archaeology_nerubian_obelisk',
    expansionId: Expansion.BattleForAzeroth,
    assetExpansionId: Expansion.BattleForAzeroth,
    patchId: ExpansionPatch.Patch_830,
    assetPatchId: ExpansionPatch.Patch_830,
    blizzardSeasonId: 4,
    isMainSeason: true,
    allowedDungeonPatches: ['8.0', '8.1', '8.1.5', '8.2', '8.3'],
    supportsAffixes: true,
    supportsSpecs: true,
    supportsFactions: true,
    loadoutFeatures: ['azerite', 'essences', 'talents', 'corruption'],
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    starts: {
      us: moment.utc('2020-01-21T15:00:00'),
      eu: moment.utc('2020-01-22T07:00:00'),
      tw: moment.utc('2020-01-22T23:00:00'),
      kr: moment.utc('2020-01-22T23:00:00'),
      cn: moment.utc('2020-01-22T23:00:00')
    },
    ends: {
      us: moment.utc('2020-10-13T15:00:00'),
      eu: moment.utc('2020-10-14T07:00:00'),
      tw: moment.utc('2020-10-14T23:00:00'),
      kr: moment.utc('2020-10-14T23:00:00'),
      cn: moment.utc('2020-10-14T23:00:00')
    }
  },
  {
    id: 18,
    slug: 'season-bfa-3-post',
    name: 'Post-Season 3',
    short_name: 'BFA3-P',
    scoringSystem: TScoringSystem.V3,
    title: 'BFA Post-Season 3',
    affix: 'Beguiling',
    affixId: 119,
    affixThreshold: [2, 4, 7, 10],
    icon: 'spell_shadow_mindshear',
    expansionId: Expansion.BattleForAzeroth,
    assetExpansionId: Expansion.BattleForAzeroth,
    patchId: ExpansionPatch.Patch_820,
    assetPatchId: ExpansionPatch.Patch_820,
    blizzardSeasonId: 3,
    isMainSeason: false,
    allowedDungeonPatches: ['8.0', '8.1', '8.1.5', '8.2', '8.3'],
    supportsAffixes: true,
    supportsSpecs: true,
    supportsFactions: true,
    loadoutFeatures: ['azerite', 'essences', 'talents'],
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    starts: {
      us: moment.utc('2020-01-14T15:00:00'),
      eu: moment.utc('2020-01-15T07:00:00'),
      tw: moment.utc('2020-01-15T23:00:00'),
      kr: moment.utc('2020-01-15T23:00:00'),
      cn: moment.utc('2020-01-15T23:00:00')
    },
    ends: {
      us: moment.utc('2020-01-21T15:00:00'),
      eu: moment.utc('2020-01-22T07:00:00'),
      tw: moment.utc('2020-01-22T23:00:00'),
      kr: moment.utc('2020-01-22T23:00:00'),
      cn: moment.utc('2020-01-22T23:00:00')
    }
  },
  {
    id: 19,
    slug: 'season-bfa-3',
    name: 'Season 3',
    short_name: 'BFA3',
    scoringSystem: TScoringSystem.V3,
    title: 'BFA Season 3',
    affix: 'Beguiling',
    affixId: 119,
    affixThreshold: [2, 4, 7, 10],
    icon: 'spell_shadow_mindshear',
    expansionId: Expansion.BattleForAzeroth,
    assetExpansionId: Expansion.BattleForAzeroth,
    patchId: ExpansionPatch.Patch_820,
    assetPatchId: ExpansionPatch.Patch_820,
    blizzardSeasonId: 3,
    isMainSeason: true,
    allowedDungeonPatches: ['8.0', '8.1', '8.1.5', '8.2'],
    supportsAffixes: true,
    supportsSpecs: true,
    supportsFactions: true,
    loadoutFeatures: ['azerite', 'essences', 'talents'],
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    starts: {
      us: moment.utc('2019-07-09T15:00:00'),
      eu: moment.utc('2019-07-10T07:00:00'),
      tw: moment.utc('2019-07-10T23:00:00'),
      kr: moment.utc('2019-07-10T23:00:00'),
      cn: moment.utc('2019-07-10T23:00:00')
    },
    ends: {
      us: moment.utc('2020-01-14T15:00:00'),
      eu: moment.utc('2020-01-15T07:00:00'),
      tw: moment.utc('2020-01-15T23:00:00'),
      kr: moment.utc('2020-01-15T23:00:00'),
      cn: moment.utc('2020-01-15T23:00:00')
    }
  },
  {
    id: 20,
    slug: 'season-bfa-2-post',
    name: 'Post-Season 2',
    short_name: 'BFA2-P',
    scoringSystem: TScoringSystem.V3,
    title: 'BFA Post-Season 2',
    affix: 'Reaping',
    affixId: 117,
    affixThreshold: [2, 4, 7, 10],
    icon: 'ability_racial_embraceoftheloa_bwonsomdi',
    expansionId: Expansion.BattleForAzeroth,
    assetExpansionId: Expansion.BattleForAzeroth,
    patchId: ExpansionPatch.Patch_810,
    assetPatchId: ExpansionPatch.Patch_810,
    blizzardSeasonId: 2,
    isMainSeason: false,
    supportsSpecs: true,
    supportsAffixes: true,
    supportsFactions: true,
    loadoutFeatures: ['azerite', 'talents'],
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    starts: {
      us: moment.utc('2019-06-25T15:00:00'),
      eu: moment.utc('2019-06-26T07:00:00'),
      tw: moment.utc('2019-06-26T23:00:00'),
      kr: moment.utc('2019-06-26T23:00:00'),
      cn: moment.utc('2019-06-26T23:00:00')
    },
    ends: {
      us: moment.utc('2019-07-09T15:00:00'),
      eu: moment.utc('2019-07-10T07:00:00'),
      tw: moment.utc('2019-07-10T23:00:00'),
      kr: moment.utc('2019-07-10T23:00:00'),
      cn: moment.utc('2019-07-10T23:00:00')
    }
  },
  {
    id: 21,
    slug: 'season-bfa-2',
    name: 'Season 2',
    short_name: 'BFA2',
    scoringSystem: TScoringSystem.V3,
    title: 'BFA Season 2',
    affix: 'Reaping',
    affixId: 117,
    affixThreshold: [2, 4, 7, 10],
    icon: 'ability_racial_embraceoftheloa_bwonsomdi',
    expansionId: Expansion.BattleForAzeroth,
    assetExpansionId: Expansion.BattleForAzeroth,
    patchId: ExpansionPatch.Patch_810,
    assetPatchId: ExpansionPatch.Patch_810,
    blizzardSeasonId: 2,
    supportsSpecs: false,
    supportsAffixes: true,
    isMainSeason: true,
    loadoutFeatures: ['azerite'],
    supportsFactions: true,
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    starts: {
      us: moment.utc('2019-01-22T15:00:00'),
      eu: moment.utc('2019-01-23T07:00:00'),
      tw: moment.utc('2019-01-23T23:00:00'),
      kr: moment.utc('2019-01-23T23:00:00'),
      cn: moment.utc('2019-01-23T23:00:00')
    },
    ends: {
      us: moment.utc('2019-06-25T15:00:00'),
      eu: moment.utc('2019-06-26T07:00:00'),
      tw: moment.utc('2019-06-26T23:00:00'),
      kr: moment.utc('2019-06-26T23:00:00'),
      cn: moment.utc('2019-06-26T23:00:00')
    }
  },
  {
    id: 22,
    slug: 'season-bfa-1',
    name: 'Season 1',
    short_name: 'BFA1',
    scoringSystem: TScoringSystem.V3,
    title: 'BFA Season 1',
    affix: 'Infested',
    affixId: 16,
    affixThreshold: [2, 4, 7, 10],
    icon: 'achievement_nazmir_boss_ghuun',
    expansionId: Expansion.BattleForAzeroth,
    assetExpansionId: Expansion.BattleForAzeroth,
    patchId: ExpansionPatch.Patch_800,
    assetPatchId: ExpansionPatch.Patch_800,
    blizzardSeasonId: 1,
    isMainSeason: true,
    supportsSpecs: false,
    supportsAffixes: true,
    loadoutFeatures: ['azerite'],
    supportsFactions: false,
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    starts: {
      us: moment.utc('2018-09-01T15:00:00'),
      eu: moment.utc('2018-09-01T07:00:00'),
      tw: moment.utc('2018-09-01T23:00:00'),
      kr: moment.utc('2018-09-01T23:00:00'),
      cn: moment.utc('2018-09-01T23:00:00')
    },
    ends: {
      us: moment.utc('2019-01-22T15:00:00'),
      eu: moment.utc('2019-01-23T07:00:00'),
      tw: moment.utc('2019-01-23T23:00:00'),
      kr: moment.utc('2019-01-23T23:00:00'),
      cn: moment.utc('2019-01-23T23:00:00')
    }
  },
  {
    id: 23,
    slug: 'season-pre-bfa',
    name: 'Pre-BFA',
    short_name: 'Pre BFA',
    scoringSystem: TScoringSystem.V3,
    title: 'BFA Pre-Season',
    expansionId: Expansion.Legion,
    affixThreshold: [4, 7, 10],
    assetExpansionId: Expansion.Legion,
    patchId: ExpansionPatch.Patch_700,
    assetPatchId: ExpansionPatch.Patch_700,
    blizzardSeasonId: 0,
    isMainSeason: false,
    supportsSpecs: false,
    supportsAffixes: true,
    supportsFactions: false,
    loadoutFeatures: ['legendaries', 'tier', 'artifacts'],
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    starts: {
      us: moment.utc('2018-07-17T15:00:00'),
      eu: moment.utc('2018-07-18T07:00:00'),
      tw: moment.utc('2018-07-18T23:00:00'),
      kr: moment.utc('2018-07-18T23:00:00'),
      cn: moment.utc('2018-07-18T23:00:00')
    },
    ends: {
      us: moment.utc('2018-09-01T15:00:00'),
      eu: moment.utc('2018-09-01T07:00:00'),
      tw: moment.utc('2018-09-01T23:00:00'),
      kr: moment.utc('2018-09-01T23:00:00'),
      cn: moment.utc('2018-09-01T23:00:00')
    }
  },
  {
    id: 24,
    slug: 'season-post-legion',
    name: 'Post-Legion',
    short_name: 'Post Legion',
    scoringSystem: TScoringSystem.V3,
    title: 'Legion Post-Season',
    affixThreshold: [4, 7, 10],
    expansionId: Expansion.Legion,
    assetExpansionId: Expansion.Legion,
    patchId: ExpansionPatch.Patch_700,
    assetPatchId: ExpansionPatch.Patch_700,
    blizzardSeasonId: 0,
    isMainSeason: false,
    supportsSpecs: false,
    supportsAffixes: true,
    supportsFactions: false,
    loadoutFeatures: ['legendaries', 'tier', 'artifacts'],
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    starts: {
      us: moment.utc('2018-06-26T15:00:00'),
      eu: moment.utc('2018-06-27T07:00:00'),
      tw: moment.utc('2018-06-27T23:00:00'),
      kr: moment.utc('2018-06-27T23:00:00'),
      cn: moment.utc('2018-06-27T23:00:00')
    },
    ends: {
      us: moment.utc('2018-07-17T15:00:00'),
      eu: moment.utc('2018-07-18T07:00:00'),
      tw: moment.utc('2018-07-18T23:00:00'),
      kr: moment.utc('2018-07-18T23:00:00'),
      cn: moment.utc('2018-07-18T23:00:00')
    }
  },
  {
    id: 25,
    slug: 'season-7.3.2',
    name: '7.3.2',
    short_name: '7.3.2',
    scoringSystem: TScoringSystem.V3,
    title: 'Season 7.3.2',
    expansionId: Expansion.Legion,
    assetExpansionId: Expansion.Legion,
    patchId: ExpansionPatch.Patch_700,
    assetPatchId: ExpansionPatch.Patch_700,
    blizzardSeasonId: 0,
    isMainSeason: true,
    supportsSpecs: false,
    supportsAffixes: true,
    supportsFactions: false,
    loadoutFeatures: ['legendaries', 'tier', 'artifacts'],
    affixThreshold: [4, 7, 10],
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    starts: {
      us: moment.utc('2017-11-28T15:00:00'),
      eu: moment.utc('2017-11-29T07:00:00'),
      tw: moment.utc('2017-11-29T23:00:00'),
      kr: moment.utc('2017-11-29T23:00:00'),
      cn: moment.utc('2017-11-29T23:00:00')
    },
    ends: {
      us: moment.utc('2018-06-26T15:00:00'),
      eu: moment.utc('2018-06-27T07:00:00'),
      tw: moment.utc('2018-06-27T23:00:00'),
      kr: moment.utc('2018-06-27T23:00:00'),
      cn: moment.utc('2018-06-27T23:00:00')
    }
  },
  {
    id: 26,
    slug: 'season-7.3.0',
    name: '7.3.0',
    short_name: '7.3.0',
    scoringSystem: TScoringSystem.V3,
    title: 'Season 7.3',
    expansionId: Expansion.Legion,
    assetExpansionId: Expansion.Legion,
    patchId: ExpansionPatch.Patch_700,
    assetPatchId: ExpansionPatch.Patch_700,
    blizzardSeasonId: 0,
    isMainSeason: true,
    supportsSpecs: false,
    supportsAffixes: true,
    supportsFactions: false,
    loadoutFeatures: ['legendaries', 'tier', 'artifacts'],
    affixThreshold: [4, 7, 10],
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    starts: {
      us: moment.utc('2017-08-29T15:00:00'),
      eu: moment.utc('2017-08-30T07:00:00'),
      tw: moment.utc('2017-08-30T23:00:00'),
      kr: moment.utc('2017-08-30T23:00:00'),
      cn: moment.utc('2017-08-30T23:00:00')
    },
    ends: {
      us: moment.utc('2017-11-28T15:00:00'),
      eu: moment.utc('2017-11-29T07:00:00'),
      tw: moment.utc('2017-11-29T23:00:00'),
      kr: moment.utc('2017-11-29T23:00:00'),
      cn: moment.utc('2017-11-29T23:00:00')
    }
  },
  {
    id: 27,
    slug: 'season-7.2.5',
    name: '7.2.5',
    short_name: '7.2.5',
    scoringSystem: TScoringSystem.V3,
    title: 'Season 7.2.5',
    expansionId: Expansion.Legion,
    assetExpansionId: Expansion.Legion,
    patchId: ExpansionPatch.Patch_700,
    assetPatchId: ExpansionPatch.Patch_700,
    blizzardSeasonId: 0,
    isMainSeason: true,
    supportsSpecs: false,
    supportsAffixes: true,
    supportsFactions: false,
    loadoutFeatures: ['legendaries', 'tier', 'artifacts'],
    affixThreshold: [4, 7, 10],
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    starts: {
      us: moment.utc('2017-06-13T15:00:00'),
      eu: moment.utc('2017-06-14T07:00:00'),
      tw: moment.utc('2017-06-14T23:00:00'),
      kr: moment.utc('2017-06-14T23:00:00'),
      cn: moment.utc('2017-06-14T23:00:00')
    },
    ends: {
      us: moment.utc('2017-08-29T15:00:00'),
      eu: moment.utc('2017-08-30T07:00:00'),
      tw: moment.utc('2017-08-30T23:00:00'),
      kr: moment.utc('2017-08-30T23:00:00'),
      cn: moment.utc('2017-08-30T23:00:00')
    }
  },
  {
    id: 28,
    slug: 'season-7.2.0',
    name: '7.2.0',
    short_name: '7.2.0',
    scoringSystem: TScoringSystem.V3,
    title: 'Season 7.2',
    expansionId: Expansion.Legion,
    assetExpansionId: Expansion.Legion,
    patchId: ExpansionPatch.Patch_700,
    assetPatchId: ExpansionPatch.Patch_700,
    blizzardSeasonId: 0,
    isMainSeason: true,
    supportsSpecs: false,
    supportsAffixes: true,
    supportsFactions: false,
    loadoutFeatures: ['legendaries', 'tier', 'artifacts'],
    affixThreshold: [4, 7, 10],
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    starts: {
      us: moment.utc('2017-03-28T15:00:00'),
      eu: moment.utc('2017-03-29T07:00:00'),
      tw: moment.utc('2017-03-29T23:00:00'),
      kr: moment.utc('2017-03-29T23:00:00'),
      cn: moment.utc('2017-03-29T23:00:00')
    },
    ends: {
      us: moment.utc('2017-06-13T15:00:00'),
      eu: moment.utc('2017-06-14T07:00:00'),
      tw: moment.utc('2017-06-14T23:00:00'),
      kr: moment.utc('2017-06-14T23:00:00'),
      cn: moment.utc('2017-06-14T23:00:00')
    }
  }
  // {
  //   name: 'season1',
  //   starts: {
  //     us: moment.utc('2016-08-30T07:00:00'),
  //     eu: moment.utc('2016-08-30T07:00:00'),
  //     tw: moment.utc('2016-08-30T07:00:00'),
  //     kr: moment.utc('2016-08-30T07:00:00'),
  //     cn: moment.utc('2016-08-30T07:00:00'),
  //   } as any
  // },,
];

export const SEASONS_BY_SLUG = new Map<string, TSeasonDef>(SEASONS.map((season: TSeasonDef) => [season.slug, season]));

// Safety check
{
  const activeSeasons = SEASONS.filter((s) => s.ends.us === FAR_FUTURE_DATE && s.starts.us !== FAR_FUTURE_DATE).length;
  if (activeSeasons > MAX_ALLOWED_ACTIVE_SEASON) {
    throw new Error(
      `There's ${activeSeasons} active seasons where a maximum of ${MAX_ALLOWED_ACTIVE_SEASON} is required.`
    );
  }

  const partitionIds = new Set<number>();
  const seasonIds = new Set<number>();
  SEASONS.forEach((s) => {
    if (seasonIds.has(s.id)) {
      throw new Error(`There's already a season using this id #${s.id}. Found duplicate in ${s.name}`);
    }
    seasonIds.add(s.id);

    if (s.partition?.eventId) {
      if (partitionIds.has(s.partition.eventId)) {
        throw new Error(
          `There's already a season using this eventid #${s.partition.eventId}. Found duplicate in ${s.name}`
        );
      }

      partitionIds.add(s.partition.eventId);
    }
  });
}

/**
 * @deprecated Should use SEASONS_BY_SLUG instead
 */
export const SEASONS_BY_EXACT_SLUGS: { [key: string]: TSeasonDef } = SEASONS.reduce((accum: any, item: any) => {
  accum[item.slug] = item;
  return accum;
}, {});

const SEASON_EVENT_TITLES: { [key: string]: string } = {
  'season-sl-2-event-break-the-meta': 'Break the Meta',
  'season-sl-2-event-keystone-builders': 'Keystone Builders Tournament',
  'season-sl-3-event-class-clash': 'Class Clash',
  'season-df-1-event-dungeon-dojo-invitational': 'Dungeon Dojo Invitational'
};

export function getEventTitleFromSeasonSlug(slug: string) {
  return SEASON_EVENT_TITLES[slug] || '';
}
